{
    "Api tokens": {
        "add token": "Adicionar token",
        "description": "Gera um token API para download de arquivos OEM para TCT e Configurator ou token API para o aplicativo usar ao solicitar serviços FOTA WEB. A documentação da API pode ser encontrada <1>aqui</1>.",
        "example": "Por exemplo: fota_token",
        "generate token": "Gerar token",
        "generated token": "Token gerado",
        "last used at": "Último uso em",
        "name": "Nome do token",
        "never": "Nunca",
        "no tokens": "Não há tokens disponíveis",
        "no tokens description": "Depois que os tokens forem adicionados, eles serão listados aqui abaixo",
        "show token list": "Mostrar lista de tokens",
        "titles": {
            "Integration": {
                "description": "Utilizado para integração FOTA WEB no seu sistema",
                "name": "Token de integração API"
            },
            "Tct": {
                "description": "Usado para download de arquivos OEM para TCT e Configurator",
                "name": "Token TCT"
            }
        },
        "tokens": "Tokens API",
        "token type": "Tipo de token",
        "token was created": "O token foi criado com sucesso"
    },
    "Attributes": {
        "Completed": "Concluído",
        "Count": "Contar",
        "Current": "Atual",
        "Date": "Data",
        "Empty": "Vazio",
        "excluded files": "Arquivos excluídos (samegrade)",
        "Failed": "Falha",
        "Feature": "Recurso",
        "file size bytes": "Tamanho total do arquivo",
        "File_type": "Tipo de arquivo",
        "File_version": "Versão do arquivo",
        "Fingerprint_id": "Identificação por impressão digital",
        "Firmware_date": "Data do firmware",
        "Firmware_version": "Revisão",
        "included files": "Arquivos incluídos",
        "Message": "Mensagem",
        "Metadata": "",
        "newest": "Desde o mais recente",
        "oldest": "Do mais antigo",
        "Order": "Encomendar",
        "Password_source": "",
        "Pending": "Pendente",
        "Period": "Período",
        "Process_id": "",
        "Protocol_id": "ID do protocolo",
        "specific": "Específico",
        "Start": "Iniciar",
        "SystemGenerated": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Firmware BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Firmware CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Firmware TAPP"
        },
        "UserEntered": "",
        "vehicle": "Veículo",
        "Vehicle_id": "Identificação do veículo",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Verifique seu aplicativo autenticador",
            "check email": "Verifique seu e-mail",
            "code required": "Código de verificação necessário.",
            "code sent to email": "Código enviado para o seu e-mail",
            "code valid": "O código é válido por alguns minutos.",
            "enter code below": "e insira o código abaixo para fazer login.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Código de verificação necessário. Verifique seu aplicativo autenticador e insira o código abaixo para fazer login.",
        "check email": "Verifique sua caixa de entrada e clique no link recebido para redefinir a senha.",
        "community forum": "Fórum de suporte coletivo",
        "contact us": "Entre em contato conosco",
        "create initial password": "Criar senha",
        "create password": "Crie uma senha que",
        "did not receive": "Não recebeu o link?",
        "do not have account": "Ainda não tem uma conta?",
        "email": "E-mail",
        "enter email": "Insira seu e-mail registrado abaixo para receber instruções para redefinir sua senha.",
        "forgot password": "Esqueceu a senha?",
        "forgot your password": "Esqueceu sua senha?",
        "for ms365": "Para usuários do Teltonika MS365",
        "invalid email format": "Formato de e-mail inválido",
        "invalid password format": "Formato de senha inválido",
        "link sent": "O link foi enviado!",
        "length": "Mínimo de 8 caracteres",
        "lowercase": "Contém pelo menos uma letra minúscula",
        "new password": "Nova senha",
        "password": "Senha",
        "passwords do not match": "As senhas não correspondem",
        "privacy policy": "Ao utilizar o FOTA WEB, você concorda com a nossa <1>Política de Privacidade</1>.",
        "remember password": "Você se lembra da sua senha?",
        "repeat password": "Repita a senha",
        "required": "Obrigatório",
        "resend": "Reenviar",
        "reset password": "Redefinir senha",
        "send reset link": "Enviar link de redefinição",
        "sign in": "Entrar",
        "sign in to fota": "Faça login na sua conta FOTA WEB",
        "signup": "Inscreva-se",
        "sso": "Faça login com a Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Letra maiúscula",
        "user consent text": "Compreendo e aceito os <1>Termos de Serviço</1> da Teltonika e o <2>Acordo de Processamento de Dados</2>.",
        "welcome": "Bem-vindo ao",
        "wiki": "Base de conhecimento da Wiki Telemática"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Aceitar",
        "accept all": "Aceitar tudo",
        "accept selected": "Aceitar selecionado",
        "actions": "Ações",
        "add": "Adicionar",
        "add device": "Adicionar dispositivo",
        "add more files": "Adicione mais arquivos",
        "add new": "Adicionar novo",
        "agree": "Concordo",
        "all companies": "Todas as empresas",
        "all of company": "Tudo da {{companyName}}",
        "all rows selected": {
            "devices": "Todos os {{count}} dispositivos foram selecionados",
            "tasks": "Todas as {{count}} tarefas pendentes/em execução são selecionadas",
            "groups": "Todos os {{count}} grupos estão selecionados",
            "files": "Todos os {{count}} arquivos foram selecionados",
            "companies": "Todas as {{count}} empresas foram selecionadas",
            "users": "Todos os {{count}} usuários são selecionados"
        },
        "approve": "Aprovar",
        "assign": "Atribuir",
        "assigning": "Atribuição",
        "auto sync": "",
        "back": "Voltar",
        "back to sign in": "Voltar para fazer login",
        "cancel": "Cancelar",
        "cancelling": "Cancelamento",
        "cancel all tasks in group": "Cancelar todas as tarefas do grupo",
        "cancel tasks": "Cancelar tarefas",
        "cannot create desktop licenses": "Não é possível criar licenças para empresas internas.",
        "cannot create offline licenses": "Não é possível criar licenças offline para licenças irrestritas.",
        "change": "Alterar",
        "clear all": "Limpar tudo",
        "clear all filters": "Limpar todos os filtros",
        "close": "Fechar",
        "company settings": "Configurações da empresa",
        "confirm": "Confirmar",
        "continue": "Continuar",
        "copied": "Copiado",
        "copy all": "",
        "copy to clipboard": "Copiar para a área de transferência",
        "create": "Criar",
        "create role": "Criar função",
        "create task": "Criar tarefa",
        "creating": "Criação",
        "default view": "Visualização padrão",
        "delete": "Excluir",
        "deleting": "Exclusão",
        "deselect all": "Desmarcar tudo",
        "device": "Dispositivo",
        "disable": "Desativar",
        "disagree": "Discordo",
        "discard": "Descartar",
        "download": "",
        "edit": "Editar",
        "enable": "Ativar",
        "export": "Exportar",
        "exporting": "Exportação",
        "filters": "Filtros",
        "finish": "",
        "find tool": "Encontrar ferramenta",
        "first page": "Primeira página",
        "fmx and legacy": "FMx e Legacy",
        "ft platform": "Plataforma FT",
        "generate": "Gerar",
        "generate codes": "",
        "go back": "Voltar",
        "import": "Importar",
        "importing": "Importação",
        "invite": "Convidar",
        "invite user": "Convidar usuário",
        "invite user to internal disabled": "Apenas o gerente administrativo e níveis de acesso superiores podem convidar usuários para empresas internas.",
        "language": "Idioma",
        "last page": "Última página",
        "logout": "Sair",
        "maximize details": "Maximize os detalhes",
        "merge": "Mesclar",
        "merging": "Fusão",
        "minimize details": "Minimizar detalhes",
        "more actions": "Mais ações",
        "more filters": "Mais filtros",
        "more options": "Mais opções",
        "move": "Mover",
        "moving": "Movimentação",
        "next": "Próximo",
        "next month": "No próximo mês",
        "next page": "Próxima página",
        "no actions available": "Nenhuma ação disponível",
        "no permission": "Você precisa da permissão \"{{permissionName}}\".",
        "no permissions": "Você precisa das seguintes permissões: {{permissionNames}}.",
        "notify when done": "Notifique-me quando estiver pronto",
        "number of selected companies": "{{companyCount}} de {{companyName}}",
        "only essential": "Apenas o essencial",
        "open fota web": "Open FOTA WEB",
        "pages of": "de {{total}}",
        "previous month": "Mês anterior",
        "previous page": "Página anterior",
        "print": "",
        "receive devices": "Receber dispositivos",
        "refresh page": "Atualizar",
        "reject all": "Rejeitar tudo",
        "reset to default": "Redefinir para os padrões",
        "retry failed tasks": "Repetir tarefas com falha",
        "retrying": "Repetindo a tentativa",
        "return home": "Vamos para casa",
        "revert manual level change": "Reverter alteração manual de nível",
        "rows count per page": "Contagem de linhas por página",
        "rows selected": "{{count}} Selecionado",
        "save": "Salvar",
        "saving": "",
        "see all": "Ver tudo",
        "select all": {
            "devices": "Selecione todos os {{count}} dispositivos",
            "tasks": "Selecionar todas as {{count}} tarefas pendentes/em execução",
            "groups": "Selecionar todos os {{count}} grupos",
            "files": "Selecionar todos os {{count}} arquivos",
            "companies": "Selecionar todas as {{count}} empresas",
            "users": "Selecionar todos os {{count}} usuários"
        },
        "select columns to show": "Selecione as colunas a serem exibidas",
        "selected page is first": "A página selecionada é a primeira",
        "selected page is last": "A página selecionada é a última",
        "select rows": "Selecionar linhas",
        "send code": "Enviar código",
        "settings": "Configurações",
        "show me": "Mostrar",
        "show more": "Mostrar mais",
        "synchronize": "Sincronizar",
        "table statistics": "Estatísticas da tabela",
        "table view": "Exibição em tabela",
        "transfer": "Transferência",
        "transferring": "Transferência",
        "transfer my devices": "Transferir meus dispositivos",
        "undo": "Desfazer",
        "upload": "Upload",
        "upload file": "Carregar novo arquivo",
        "user": "Usuário",
        "verify": "Verificar",
        "yes": "Sim"
    },
    "Cookies": {
        "always active": "Sempre ativo",
        "analytics cookies": "Cookies analíticos",
        "analytics cookies description": "Esses rastreadores são usados para análises que ajudam a coletar dados que nos permitem entender como os usuários interagem com nossos sites. Essas informações nos permitem melhorar o conteúdo e criar recursos melhores que aprimoram a experiência do usuário. Essa categoria de cookies pode ser desativada.",
        "cookie banner message": "Nós e terceiros selecionados utilizamos cookies ou tecnologias semelhantes para fins técnicos e, com o seu consentimento, para outros fins, conforme especificado na ",
        "cookie modal title": "Utilizamos cookies",
        "cookie policy": "Política de cookies",
        "essential cookies": "Cookies essenciais",
        "essential cookies description": "Esses rastreadores são usados para atividades estritamente necessárias para operar ou fornecer o serviço que você solicitou e não coletam informações sobre você que possam ser usadas para fins de marketing, nem lembram onde você esteve na Internet. Essa categoria de cookies não pode ser desativada."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Elementos essenciais para atualização remota de dispositivos",
                "Standard": "Automação e integração avançadas",
                "Premium": "Escalabilidade empresarial e acesso antecipado a atualizações"
            },
            "resource limit types": {
                "Companies": "Empresas",
                "Users": "Usuários",
                "ConfigurationFiles": "Arquivos de configuração"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Assim que as configurações forem detectadas pelo FOTA WEB, você poderá ver a lista aqui.",
                "firmware versions": "Assim que as versões do firmware forem detectadas pelo FOTA WEB, você poderá ver a lista aqui."
            },
            "title": {
                "configurations": "Nenhuma configuração detectada",
                "firmware versions": "Nenhuma versão de firmware detectada",
                "news": "Sem notícias para mostrar"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Hoje",
                "7": "7 dias",
                "30": "30 dias",
                "90": "90 dias"
            },
            "period": "Período"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Gostaríamos de lembrar que, para usuários convidados após 7 de janeiro de 2025, a autenticação de dois fatores (2FA) será obrigatória imediatamente após a ativação da conta. A autenticação de dois fatores está disponível por meio de verificação por e-mail ou aplicativo autenticador.",
                "2": "Gostaríamos de informá-lo sobre a manutenção planejada do FOTA WEB, que ocorrerá em 3 de junho de 2025, a partir das 05:00 UTC. Leve em consideração que, durante a manutenção, todos os serviços estarão indisponíveis, incluindo interface do usuário, acesso à API, execução de tarefas, OBD e serviços CAN. O tempo estimado de indisponibilidade do serviço é de 1 hora.",
                "3": "<section><p>Temos o prazer de anunciar uma importante melhoria no recurso Device Unlocker (Desbloqueador de dispositivos) no FOTA WEB:</p></section> <section><p>Todas as funções de usuário agora podem desbloquear dispositivos diretamente — sem necessidade de entrar em contato com o Suporte Técnico através do Helpdesk!</p> <p>Detalhes importantes:</p> <ul><li>Os usuários podem desbloquear o mesmo dispositivo até 3 vezes em um período de 24 horas.</li> <li>Após atingir o limite, a opção de desbloqueio ficará temporariamente desativada por 24 horas.</li> <li>Se o limite de desbloqueio for excedido, uma mensagem de erro será exibida. Esta atualização reduz significativamente os tempos de espera e oferece mais controle sobre o gerenciamento da sua frota.</li></ul></section> <section><a>Saiba como usar o recurso</a></section>",
                "4": "<section><p>Temos o prazer de anunciar algumas novidades incríveis no painel do FOTA WEB! Trabalhamos para melhorar sua experiência com widgets aprimorados e novos insights. </p></section> <section><h3>Novas estatísticas de dispositivos</h3> <p>Obtenha melhores insights sobre a atividade do seu dispositivo com dois novos widgets:</p> <p><strong>Dispositivos ativados</strong>: Esta nova estatística mostra quantos dispositivos foram ativados (conectados) em vários períodos: hoje, 7 dias, 30 dias ou 90 dias. </p> <p><strong>Dispositivos importados</strong>: Da mesma forma, a nova estatística Dispositivos importados rastreia quantos dispositivos foram importados hoje, nos últimos 7 dias, 30 dias ou 90 dias.</p> </section> <section><h3>Apresentando o widget Tarefas</h3> <p>Acompanhe suas operações com o novo widget Tarefas:</p> <p><strong>Tarefas em fila</strong>: veja uma contagem clara de suas tarefas pendentes no momento.</p> <p><strong>Visão geral das tarefas</strong>: obtenha uma análise detalhada da distribuição das suas tarefas por período (7 dias, 30 dias ou 90 dias) e status. Isso inclui tarefas concluídas, concluídas com erros ou com falha.</P></section> <section><h3>Visão geral mais inteligente do firmware e da configuração</h3> <p>Aprimoramos os widgets Versões do firmware e Configurações:</p> <ul><li>Removemos as estatísticas “Desconhecidas” para obter dados mais claros.</li> <li>A interface do usuário agora mostra mais claramente os nomes do firmware e da configuração e suas contagens.</li> <li>Você verá inicialmente as 5 principais versões ou configurações, com a opção “Mostrar mais” para visualizar até 100 entradas diferentes. </li> <li>Passar o mouse e clicar em um firmware ou configuração específico levará você à “página Dispositivos” e aplicará um filtro.</li></ul></section> <section><h3>Widget de notícias aprimorado</h3> <p>Mantenha-se informado rapidamente! O widget de notícias tem um novo visual e agora você também pode clicar em qualquer notícia para ler as informações completas. </p></section> <section><h3>Status do dispositivo aprimorado</h3> <p>O widget Status do dispositivo foi atualizado visualmente para maior clareza. Além disso, agora você pode passar o mouse sobre o status de um dispositivo e clicar nele para filtrar os dispositivos com o status correspondente na página “Dispositivos”.</p></section> <section><p>Esperamos que essas atualizações tornem suas tarefas diárias ainda mais fáceis e forneçam informações mais valiosas. Diga-nos o que você achou!</p></section>",
                "5": "<section><h3>Alterações planejadas na API</h3></section> <section><p>Em <strong>24 de setembro de 2025</strong>, removeremos o campo “função” das respostas que retornam a entidade do usuário (por exemplo, pontos de extremidade GET /users ou GET /users/{userId}). Essa alteração está sendo feita para abrir caminho para um sistema de permissões mais robusto e flexível no FOTA WEB.</p></section> <section><h3>Antevisão: Funções e Permissões</h3></section> <section><p> Reconhecemos que o sistema de funções atual não oferece a flexibilidade de que necessita. A nossa equipa de desenvolvimento está a trabalhar arduamente numa nova funcionalidade de <strong>gestão de Funções e Permissões</strong> que lhe permitirá criar funções com controlo granular sobre as permissões.</p></section> <section><p>Este novo sistema lhe dará o poder de atribuir funções estáticas aos usuários ou personalizar permissões de acordo com suas necessidades específicas, além de criar funções personalizadas. Estamos muito animados com isso e ansiosos para compartilhar mais detalhes sobre o gerenciamento de funções e permissões quando estiverem disponíveis.</p></section>",
                "6": "Temos o prazer de anunciar o lançamento do novo recurso “Funções e Permissões”, projetado para oferecer controle preciso sobre o acesso dos usuários na FOTA WEB. Essa funcionalidade permite definir as capacidades dos usuários usando “Funções”, que são conjuntos de “Permissões” específicas (por exemplo, “Criar tarefa”, “Convidar usuário”). O recurso inclui <strong>Funções estáticas</strong> imutáveis - Administrador, Usuário e Convidado - para segurança básica, juntamente com <strong>Funções personalizadas</strong> que apenas usuários <strong>Premium de nível empresarial</strong> podem criar ou editar. As permissões agora são categorizadas em áreas-chave, como Dispositivos, Tarefas e Usuários, e podem ser visualizadas passando o mouse sobre a “Contagem de permissões” na seção de gerenciamento. <strong>Para todos os usuários existentes criados antes desta atualização, a função “Administrador” foi atribuída automaticamente, garantindo que eles mantenham toda a gama de ações que podiam realizar anteriormente.</strong></p></section> <section><p>Esta atualização garante melhor segurança e distribuição da carga de trabalho. As funções agora são específicas da empresa e não podem ser herdadas entre estruturas empresariais. Observe que uma função deve sempre ser atribuída ao convidar ou mover um usuário para uma empresa, e as funções com atribuições de usuários ativas não podem ser excluídas. Agora você pode usar o <strong>novo filtro “Função”</strong> na página <strong>Usuários</strong> para facilitar o gerenciamento. Explore a seção “Funções e permissões” hoje mesmo para configurar o acesso de acordo com as necessidades da sua organização.</p></section> <section><p>Para obter um guia detalhado sobre como gerenciar usuários e funções, visite <a>a página wiki</a>.</p></section>",
                "7": "<section><p>Estamos entusiasmados em lançar uma nova e poderosa maneira de gerenciar suas tarefas com o recurso <strong>Agendar por data</strong>, oferecendo maior precisão para trabalhos urgentes!</p></section> <section><h3>Principais destaques</h3></section> <section><ul><li><strong>Prazos específicos</strong> - Agora você pode agendar tarefas para uma <strong>data específica ou intervalo de datas</strong> usando a nova opção “Agendar por data”.</li> <li><strong>Comportamento padrão inalterado</strong> - A funcionalidade familiar <strong>Agendar por hora</strong> continua totalmente disponível. </li> <li><strong>Status de expiração</strong> - As tarefas não concluídas até a data definida agora mudarão automaticamente para o status <strong>Expirado</strong>, acompanhadas da mensagem: <strong>“A tarefa não foi concluída durante o prazo definido.”</strong></li> <li><strong>Tempo centrado no usuário</strong> - Todas as programações são criadas com base na <strong>sua hora local</strong>.</li></ul></section> <section><h3>Como funciona</h3></section> <section><p>Ao definir a tarefa <strong>“Programar por data”</strong>:</p> <ul><li>Você selecionará uma <strong>“Data de início”</strong> e uma <strong>“Data de término”</strong> por meio do componente seletor de datas.</li> <li>O seletor de datas respeita o prazo de validade das tarefas em nível da empresa.</li></ul></section><section><p>A funcionalidade <strong>Agendar por data</strong> é atualmente exclusiva para níveis mais altos da empresa e não está disponível para o nível <strong>Básico</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "2FA obrigatório para novos usuários a partir de 7 de janeiro de 2025",
                "2": "Manutenção planejada para 3 de junho de 2025",
                "3": "Atualização de novo recurso: desbloqueio de dispositivos mais fácil para todos os usuários",
                "4": "Descubra as novidades no seu painel!",
                "5": "Importante: alterações futuras na API e prévia das funções e permissões",
                "6": "Novo recurso disponível agora: controle aprimorado com “Funções e Permissões”",
                "7": "Novo recurso: mais flexibilidade com a programação de tarefas por data",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Publicado em",
        "take me there": "Leve-me até lá",
        "tasks": {
            "current": "Atual",
            "status": {
                "completed": "Concluído",
                "completed_with_errors": "Concluído com erros",
                "failed": "Falha",
                "no tasks": "Sem tarefas"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 dias",
                "tooltipTitle": "Últimos 7 dias"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 dias",
                "tooltipTitle": "Últimos 30 dias"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 dias",
                "tooltipTitle": "Últimos 90 dias"
            }
        },
        "title": {
            "activated": "Dispositivos ativados",
            "configurations": "Configurações",
            "device status": "Status do dispositivo",
            "firmware versions": "Versões de firmware",
            "imported": "Dispositivos importados",
            "news": "Notícias",
            "queued tasks": "Tarefas em fila",
            "refreshed every hour": "Atualizado a cada hora",
            "resource limits": "Limites de recursos",
            "task overview": "Visão geral das tarefas",
            "tasks": "Tarefas"
        },
        "tooltips": {
            "activated": "O número de dispositivos que se conectaram ao FOTA WEB pela primeira vez durante o período selecionado (hoje, últimos 7 dias, últimos 30 dias, últimos 90 dias).",
            "configurations": "Mostra a distribuição dos nomes dos arquivos de configuração que foram carregados para seus dispositivos. São exibidos até 100 nomes de arquivos exclusivos.",
            "firmware versions": "Exibe a distribuição das versões de firmware relatadas pelos seus dispositivos conectados. São exibidas até 100 versões exclusivas.",
            "imported": "O número de dispositivos adicionados à sua conta durante o período selecionado (Hoje, Últimos 7 dias, Últimos 30 dias, Últimos 90 dias)."
        }
    },
    "Date picker": {
        "disableFuture": "Data inválida",
        "disablePast": "Data inválida",
        "invalidDate": "Data inválida",
        "maxDate": "Data incorreta",
        "minDate": "Data incorreta",
        "shouldDisableDate": "Data inválida",
        "shouldDisableMonth": "Data inválida",
        "shouldDisableYear": "Data inválida"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Adicionar novo dispositivo",
        "add new device description": "Adicione um ou vários novos dispositivos à empresa e ao grupo selecionados. Apenas dispositivos antigos, como FM ou FMA, devem ser importados marcando a caixa de seleção “Importar como dispositivos antigos”.",
        "add new device legacy title": "Importar como dispositivos legados.",
        "add new device legacy description": "Defina “Criado em” como 01/01/2016 e “Modelo” como Legado.",
        "add new product code": "Adicionar novo código de produto",
        "add new product code description": "Adicione um novo código de produto do dispositivo e vincule-o ao pacote CAN disponível.",
        "all permissions": "Todas as permissões",
        "assign access group": "",
        "assign can package description": "Escolha um tipo de pacote e atribua-o a todos os dispositivos selecionados.",
        "assign role": "Atribuir função",
        "attribute value": "Valor do atributo",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Iniciar download",
        "by date": "Por data",
        "by time": "Por tempo",
        "can adapter": "Adaptador CAN",
        "cancel pending tasks": "Cancelar tarefas pendentes do mesmo tipo de tarefa",
        "cancel tasks": "Cancelar tarefas",
        "cancel tasks in group": {
            "alert title": "Esta ação levará alguns minutos para ser concluída.",
            "banner description": "Para ver o status atualizado das tarefas, consulte os detalhes do grupo de tarefas ou atualize a página.",
            "banner title": "Esta ação pode demorar vários minutos a ser concluída, dependendo do número de tarefas.",
            "description": "Clicar em “Aceitar” cancelará todas as tarefas pendentes e em execução. Tem certeza de que deseja continuar?",
            "title": "Cancelar todas as tarefas do grupo?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "E-mail do representante do cliente",
        "companies": "Empresas",
        "company": "Empresa",
        "company level": {
            "Basic": "Básico",
            "Internal": "Interno",
            "Premium": "Premium",
            "Standard": "Padrão"
        },
        "company level change description": "Atualize o nível da empresa selecionando o novo nível e fornecendo uma explicação do motivo. Não é possível rebaixar o nível da empresa. Todas as datas estão em UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Esta ação redefinirá o nível da empresa para o nível atribuído automaticamente “{{companyLevel}}”. Tem certeza de que deseja continuar?",
                "title": "Reverter alteração manual de nível?"
            },
            "description": "A reversão mudará o nível da empresa de volta para o nível atribuído automaticamente.",
            "title": "Este nível da empresa foi atualizado manualmente até {{expirationDate}}."
        },
        "company level type": "Tipo de nível empresarial",
        "company name": "Nome da empresa",
        "company statistics": {
            "child companies": "Contagem de empresas subsidiárias",
            "devices": "Contagem de dispositivos",
            "files": "Contagem de arquivos",
            "groups": "Contagem de grupos de dispositivos",
            "tasks": "Contagem de tarefas",
            "users": "Contagem de usuários"
        },
        "company type": {
            "All": "",
            "Client": "Cliente",
            "Internal": "Interno",
            "Virtual": "Virtual"
        },
        "configuration": "Configuração",
        "confirmations": {
            "are you sure": "Tem certeza?",
            "are you sure you wish to continue": "Tem certeza de que deseja continuar?",
            "assign can package confirmation": "Tem certeza de que deseja atribuir o pacote selecionado ao número especificado de dispositivos?",
            "cancel task confirmation": {
                "first part": "Tem certeza de que deseja cancelar o número especificado de tarefas?",
                "second part": "Se for o caso, insira o número de tarefas afetadas e clique em “Confirmar”."
            },
            "create task confirmation": "Tem certeza de que deseja criar uma tarefa para o número especificado de dispositivos?",
            "delete resource confirmation": {
                "first part": "Tem certeza de que deseja excluir o número especificado de {{resource}}?",
                "second part": "Se for o caso, insira o número de {{resource}} afetados e clique em “Excluir”."
            },
            "delete resources": {
                "companies": "empresas",
                "files": "arquivos",
                "groups": "grupos de dispositivos",
                "deviceModels": "modelos",
                "productCodes": "códigos de produto",
                "roles": "funções",
                "users": "usuários"
            },
            "description second part": "Se for o caso, insira o número de dispositivos afetados e clique em “Confirmar”.",
            "export device data confirmation": "Tem certeza de que deseja exportar os dados dos dispositivos para o número especificado de dispositivos?",
            "file": "Insira o número de linhas existentes no arquivo",
            "filter": {
                "companies": "Insira o número de empresas filtradas",
                "devices": "Insira o número de dispositivos filtrados",
                "files": "Insira o número de arquivos filtrados",
                "groups": "Insira o número de grupos de dispositivos filtrados",
                "productCodes": "Insira o número de códigos de produtos filtrados",
                "tasks": "Insira o número de tarefas filtradas",
                "users": "Insira o número de usuários filtrados"
            },
            "id_list": {
                "companies": "Insira o número de empresas selecionadas",
                "devices": "Insira o número de dispositivos selecionados",
                "files": "Insira o número de arquivos selecionados",
                "groups": "Insira o número de grupos de dispositivos selecionados",
                "productCodes": "Insira o número dos códigos dos produtos selecionados",
                "tasks": "Insira o número de tarefas selecionadas",
                "users": "Insira o número de usuários selecionados"
            },
            "merge companies confirmation": "Você está prestes a fundir as empresas {{sourceCompany}} e {{targetCompany}}.",
            "move companies confirmation": "Você está prestes a mudar da empresa {{sourceCompany}} para a empresa {{targetCompany}}.",
            "move devices confirmation": "Tem certeza de que deseja transferir o número especificado de dispositivos para outra empresa?",
            "number of lines": "Número de linhas",
            "selected 20 or more devices": "Você selecionou 20 ou mais dispositivos...",
            "transfer devices confirmation": "Tem certeza de que deseja transferir o número especificado de dispositivos para outra empresa?"
        },
        "confirm cannot revert": "Esta ação é irreversível.",
        "confirm merge companies": "Tem certeza de que deseja mesclar essas empresas?",
        "count": "Contar",
        "create company": "Criar empresa",
        "create company description": "Crie uma nova empresa sob a empresa-mãe selecionada.",
        "create desktop license": "Criar licença para desktop",
        "create desktop license description": "Emitir uma nova licença FOTA Desktop para a empresa cliente com seu IP, chave de hardware e validade (máximo de 2 anos).",
        "create group": "Criar grupo",
        "create group description": "Organize os dispositivos em grupos para simplificar o gerenciamento e a atribuição em massa.",
        "create model": "Criar modelo",
        "create model description": "Crie um novo modelo de dispositivo especificando o nome, a plataforma e o suporte TCT web.",
        "create offline license": "Criar licença offline",
        "create or edit group description": "O firmware e a configuração podem ser atribuídos ao grupo. Depois de feito isso, tarefas de atualização de firmware e/ou configuração serão geradas para todos os membros do grupo (dispositivos).",
        "create role": "Criar função",
        "create role description": "Crie uma nova função atribuindo-lhe um nome e uma descrição, selecionando uma empresa e atribuindo permissões específicas.",
        "create smart group": "Criar Grupo Inteligente",
        "create smart group banner message": "",
        "create smart group description": "Os arquivos de firmware e configuração podem ser atribuídos ao grupo para cada plataforma. Depois que os arquivos forem atribuídos, as tarefas de atualização serão geradas para todos os dispositivos do grupo.",
        "create task description first step": "Crie uma ampla variedade de tarefas, desde atualizar a configuração ou o firmware até receber logs, configurações e muito mais de dispositivos selecionados ou filtrados. Além disso, você pode agendar as tarefas criadas para sua conveniência.",
        "create task description last step": "Certifique-se de que as informações abaixo estão corretas antes de criar a tarefa.",
        "current level": "nível atual",
        "custom resource limits": {
            "at least one limit must be higher": "Pelo menos um limite deve ser superior ao valor padrão do nível Premium.",
            "configuration files per device": "Arquivos de configuração por dispositivo",
            "confirmation modal description": "Tem certeza de que deseja alterar os seguintes limites de recursos da empresa “{{companyName}}”?",
            "confirmation modal title": "Alterar os limites de recursos da empresa?",
            "count": {
                "companies count": "Número de empresas: {{number}}",
                "configuration files per device count": "Contagem de arquivos de configuração por dispositivo: {{number}}",
                "tasks per group count": "Contagem de tarefas por grupo: {{number}}",
                "users count": "Número de usuários: {{number}}"
            },
            "explanations": {
                "companies": "O número total de empresas subsidiárias que podem ser criadas na hierarquia da empresa.",
                "configuration files per device": "O número de arquivos de configuração que podem ser armazenados é de 1 dispositivo por 1 arquivo de configuração. A quantidade mínima garantida de arquivos de configuração é de 100 para cada nível da empresa.",
                "tasks per group": "O número de tarefas que podem estar em um grupo de tarefas.",
                "users": "O número total de usuários que podem ser criados na hierarquia da empresa."
            },
            "main modal description": "Defina uma quantidade personalizada de recursos para diferentes tipos de recursos, como empresas, usuários, tarefas por grupo de tarefas ou arquivos de configuração. Os recursos personalizados permanecerão ativos até o vencimento do nível Premium ou até que sejam redefinidos manualmente.",
            "resources limit type": "Tipo de limite de recursos",
            "revert custom resource limits": "Reverter limites de recursos personalizados",
            "revert custom resource limits description": "Redefinir todos os limites irá configurá-lo para os valores padrão de recursos e alterar o nível da empresa para Premium.",
            "revert custom resource limits description confirmation": "Esta ação irá reverter os limites de recursos para os atribuídos automaticamente para o nível “Premium”. Tem certeza de que deseja continuar?",
            "revert custom resource limits title": "Os limites de recursos desta empresa foram definidos manualmente.",
            "revert custom resource limits title confirmation": "Reverter limites de recursos personalizados?",
            "tasks per group": "Tarefas por grupo"
        },
        "date range": "Intervalo de datas",
        "date to": "para",
        "delete companies": "Excluir empresas",
        "delete deviceModels": "Excluir modelos",
        "delete files": "Excluir arquivos",
        "delete file warning": "A exclusão de arquivos cancelará as tarefas e grupos de tarefas relacionados.",
        "delete groups": "Excluir grupos de dispositivos",
        "delete productCodes": "Excluir códigos de produtos",
        "delete roles": "Excluir funções",
        "delete tasks and history": "",
        "delete users": "Excluir usuários",
        "description": "Descrição",
        "desktop license delete description": "Tem certeza de que deseja excluir a licença de desktop “{{name}}”?",
        "desktop license name": "Nome da licença do desktop",
        "device identifier": "Identificador do dispositivo",
        "device transfer": {
            "main": {
                "description": "Transfira dispositivos selecionados ou filtrados para uma empresa não relacionada usando um token gerado pela empresa receptora.",
                "title": "Transferência de dispositivos"
            },
            "receive devices": {
                "copy token": "Copie e envie o token gerado para a pessoa responsável pela transferência de dispositivos da empresa dela para a sua.",
                "description": "Crie um token de dispositivo de recebimento e envie-o para a empresa de transferência.",
                "token info": "O token é de uso único e expira após 21 dias."
            },
            "transfer devices": {
                "confirmation": "Tem certeza de que deseja transferir dispositivos para uma empresa abaixo?",
                "device token": "O token de transferência do dispositivo deve ser obtido junto ao gerente da empresa para a qual você deseja transferir seus dispositivos.",
                "transfer from file": "Carregue um arquivo com a lista de dispositivos (IMEIs) que deseja transferir da sua empresa para a empresa cujo token acabou de inserir."
            }
        },
        "device transfer token": "Token de transferência de dispositivo",
        "downgrading company level is not possible": "Não é possível fazer o downgrade do nível da empresa",
        "download sample file message": "Baixe um <1>modelo CSV de amostra</1> para ver um exemplo do formato necessário.",
        "edit group banner message": "A alteração do firmware e/ou dos arquivos de configuração cancelará todas as tarefas pendentes anteriores do mesmo tipo.",
        "edit group description": "Modifique as configurações para este grupo de dispositivos.",
        "edit role description": "Personalize o nome, a descrição e as permissões da função. A empresa atribuída não pode ser alterada.",
        "edit smart group description": "Os arquivos de firmware e configuração podem ser atribuídos ou alterados ao grupo para cada plataforma. Depois que os arquivos forem atribuídos ou alterados, tarefas de atualização serão geradas para todos os dispositivos do grupo.",
        "email": "E-mail",
        "enter": "Entrar",
        "enter code": "Digite o código",
        "enter description": "Insira a descrição",
        "enter name": "Digite o nome",
        "example": "Por exemplo:",
        "expires at": "Expira em",
        "explanation": "Explicação",
        "export device data": "Exportar dados do dispositivo",
        "export device description": "",
        "export file format": "Formato de arquivo de exportação",
        "feature": "Recurso",
        "feature control": "Controle de recursos",
        "field disabled until company selected": "Este campo fica desativado até que a empresa seja selecionada.",
        "firmware": "Firmware",
        "files to download": "Arquivos para download",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "A lista de autorizações 1-Wire carregada será automaticamente classificada para melhorar a velocidade e a precisão da funcionalidade.",
                "bluetooth_authorization_list": "A lista de autorizações Bluetooth enviada será automaticamente classificada para melhorar a velocidade e a precisão da funcionalidade."
            },
            "endings": {
                "file": "arquivo",
                "files": "arquivos"
            },
            "fail": {
                "multiple": "{{failCount}} de {{totalCount}} {{fileEnding}} não foram carregados devido a um erro.",
                "single": "{{failCount}} de {{totalCount}} {{fileEnding}} não foi carregado devido a um erro."
            },
            "success": {
                "multiple": "Todos os arquivos foram adicionados com sucesso às empresas selecionadas.",
                "single": "Todos os arquivos foram adicionados com sucesso à empresa selecionada."
            }
        },
        "filtered": "Filtrado",
        "filtered companies": "Empresas filtradas",
        "filtered devices": "Dispositivos filtrados",
        "filtered files": "Arquivos filtrados",
        "filtered groups": "Grupos filtrados",
        "filtered tasks": "Tarefas filtradas",
        "filtered users": "Usuários filtrados",
        "find tool": {
            "device": {
                "error not valid": "O IMEI deve consistir em 15 caracteres",
                "error subtitle": "Dispositivo não encontrado. Tente digitar um IMEI diferente.",
                "error title": "Nenhum dispositivo encontrado",
                "link": "Ir para o dispositivo",
                "no permission": "Você não tem permissão para visualizar este dispositivo."
            },
            "user": {
                "error not valid": "Formato de e-mail inválido",
                "error subtitle": "Usuário não encontrado. Tente digitar um e-mail de usuário diferente.",
                "error title": "Nenhum usuário encontrado",
                "link": "Ir para o usuário",
                "no permission": "Você não tem permissão para visualizar este usuário."
            }
        },
        "firmware date": "Data do firmware",
        "from form": "Do formulário",
        "from file": "A partir do arquivo",
        "general": "Geral",
        "gsm_number": "Número GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Restrição IMEI",
        "import device data": "Importar dados do dispositivo",
        "import device data description": "Importa dados de atributos selecionados para os dispositivos na lista fornecida.",
        "import device data info": "Cada atributo tem um limite máximo de caracteres exibido entre parênteses. Se um atributo tiver mais caracteres do que o limite máximo, ele será automaticamente encurtado até o limite máximo.",
        "import device data limit": "(máximo de {{limit}} caracteres)",
        "imsi": "IMSI",
        "input text too long": "O texto é muito longo. O máximo permitido é {{maxLength}} caracteres.",
        "invalid hardware key": "Formato de chave de hardware inválido",
        "invalid imei": "IMEI inválido",
        "invalid ipv4": "Formato IPv4 inválido",
        "invalid serial": "Número de série inválido",
        "invalid value": "Valor inválido",
        "inverted selection": "Seleção invertida",
        "invite user": "Convidar usuário",
        "invite user description": "Convide um novo usuário para a empresa matriz selecionada e defina sua função. Após o envio, o usuário terá 30 dias para aceitar o convite antes que ele expire.",
        "invite user max roles": "É permitido um máximo de 5 funções. Desmarque uma para continuar.",
        "log files": "Arquivos de log",
        "make": "Criar",
        "manage permissions": "Gerencie todos os dados em nível de conta e site.",
        "maximum value is": "O valor máximo é {{value}}",
        "merge companies": "Mesclar empresas",
        "merge companies info": "Todos os recursos da empresa de origem (dispositivos, grupos, arquivos, empresas, usuários com suas funções) serão transferidos para a empresa de destino. Recomenda-se revisar as funções dos usuários antes da fusão. A empresa de origem será excluída posteriormente.",
        "merge companies disabled option": {
            "client to internal": "Empresas do tipo cliente não podem ser incorporadas a empresas do tipo interno.",
            "internal": "Empresas do tipo interno não podem ser mescladas.",
            "lz code": "A empresa com código não pode ser mesclada."
        },
        "minimum value is": "O valor mínimo é {{value}}",
        "move companies disabled option": {
            "internal": "Empresas do tipo interno não podem ser transferidas."
        },
        "move device": "Mover dispositivo",
        "move device description": "Mova dispositivos selecionados ou filtrados para a empresa existente e/ou grupo na hierarquia da empresa.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Mover dispositivos",
        "name": "Nome",
        "newest": "Desde o mais recente",
        "no dropdown files": {
            "description": "Para selecionar esta opção, envie um novo arquivo $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Lista de autorizações 1-Wire",
                "adas_firmware": "Firmware ADAS",
                "ble_fw": "Firmware BLE",
                "blue_nrg": "Firmware BlueNrg",
                "bluetooth_authorization_list": "Lista de autorizações Bluetooth",
                "can_chip_firmware": "Firmware do chip FM CAN",
                "carrier_advance_firmware": "Firmware Carrier Advance",
                "carrier_advance_settings": "Configurações de Carrier Advance",
                "carrier_apx_firmware": "Firmware Carrier APX",
                "carrier_apx_settings": "Configurações do Carrier APX",
                "certificate": "Certificado TLS",
                "configuration": "configuração",
                "dsm_firmware": "Firmware DSM",
                "dtb": "DTB",
                "firmware": "firmware",
                "fw_bundle": "pacote de firmware",
                "gnssm_download_assistant": "Assistente de download GNSS-M",
                "gnssm_firmware": "Firmware GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Lista de cenários de geofence manual",
                "meig_modem_firmware": "Firmware do modem MeiG",
                "netprisma_modem_firmware": "Firmware do modem NETPRISMA",
                "psub": "assinatura",
                "quectel_modem_firmware": "Firmware do modem Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Não há arquivos $t(Dialog##no dropdown files##file names##{{fileName}})."
        },
        "none": "Nenhum",
        "obd oem": "OBD OEM",
        "offline license delete description": "Tem certeza de que deseja excluir a licença offline “{{name}}”?",
        "oldest": "Do mais antigo",
        "only integers": "Apenas números inteiros são válidos",
        "only numbers": "Apenas números são válidos",
        "optional": "opcional",
        "other companies": "Outras empresas",
        "parent company": "Empresa controladora",
        "permission preset": "Permissão predefinida",
        "platform compatibility": {
            "banner text": "Alguns dos modelos de dispositivos selecionados não são compatíveis com o tipo de tarefa selecionado. Esse tipo de tarefa não será criado por padrão para modelos de dispositivos incompatíveis.",
            "compatible model devices": "Modelos de dispositivos compatíveis",
            "count text": "A tarefa será criada para <1>{{compatibleCount}}</1> dos {{totalCount}} dispositivos.",
            "create tasks for incompatible devices": "Crie tarefas para dispositivos incompatíveis.",
            "devices from file": "Dispositivos a partir de arquivos",
            "platform": "Plataforma {{title}}",
            "task applies": "A tarefa se aplica a",
            "task cannot be created": "Não é possível criar tarefas para dispositivos de modelos incompatíveis."
        },
        "receiving company": "Esta empresa receberá seus dispositivos",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Esta ação levará alguns minutos para ser concluída.",
            "banner description": "Para ver o status atualizado das tarefas, consulte os detalhes do grupo de tarefas ou atualize a página.",
            "description": "Ao clicar em “Aceitar”, todas as tarefas com falha serão repetidas. Tem certeza de que deseja continuar?",
            "title": "Repetir todas as tarefas do grupo?"
        },
        "revision": "Revisão",
        "revision value error": "O valor deve ter dois dígitos (00 - 99).",
        "role name": "Nome da função",
        "root company": "Empresa matriz",
        "sales email": "E-mail do gerente de vendas",
        "scheduled time warning": "As tarefas com horário programado não alteram a configuração do tempo de conexão FOTA do dispositivo. As tarefas serão executadas se o dispositivo se conectar ao FOTA durante o intervalo de tempo selecionado. Certifique-se de que os dispositivos estejam configurados para se conectar ao FOTA WEB em um período não inferior ao intervalo de tempo selecionado.",
        "schedule task": "Agendar tarefa",
        "select": "Selecionar",
        "select at least one": {
            "companies": "Selecione pelo menos uma empresa",
            "devices": "Selecione pelo menos um dispositivo",
            "files": "Selecione pelo menos um arquivo",
            "groups": "Selecione pelo menos um grupo",
            "tasks": "Selecione pelo menos uma tarefa",
            "users": "Selecione pelo menos um usuário"
        },
        "selected": "Selecionado",
        "selected companies": "Empresas selecionadas",
        "selected deviceModels": "Modelos selecionados",
        "selected devices": "Dispositivos selecionados",
        "selected files": "Arquivos selecionados",
        "selected groups": "Grupos de dispositivos selecionados",
        "selected productCodes": "Códigos de produtos selecionados",
        "selected roles": "Funções selecionadas",
        "selected tasks": "Tarefas selecionadas",
        "selected users": "Usuários selecionados",
        "select company": "",
        "select group": "",
        "select time interval": "Selecione o intervalo de tempo",
        "selected time window": "Intervalo de tempo selecionado: {{fromDate}} a {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Selecione os arquivos disponíveis para dispositivos da plataforma {{platformName}}.",
            "title": "Arquivos da plataforma {{platformName}}"
        },
        "sn": "Número de série.",
        "specific": "Específico",
        "time period": "Período de tempo",
        "time period custom": "Personalizado",
        "tls certificate transfer info": "",
        "token has expired": "O token expirou",
        "token is valid": "O token é válido",
        "transfer companies": "Empresas de transferência",
        "transfer companies description": "Selecione se deseja mover ou mesclar duas empresas. Algumas opções são irreversíveis.",
        "transfer devices": "Transferir dispositivos",
        "tri source": {
            "selected tab description": {
                "create task": "A tarefa escolhida será criada para os dispositivos selecionados usando a caixa de seleção.",
                "general": "A ação escolhida será executada para os dispositivos selecionados usando a caixa de seleção."
            },
            "filtered tab description": {
                "create task": "A tarefa escolhida será criada para dispositivos filtrados usando um ou mais filtros disponíveis.",
                "general": "A ação escolhida será executada para dispositivos filtrados usando um ou mais filtros disponíveis."
            },
            "from file tab description": {
                "create task": "A tarefa selecionada será criada para os dispositivos especificados no arquivo carregado.",
                "general": "A ação escolhida será executada para os dispositivos especificados no arquivo carregado."
            }
        },
        "unlocker": {
            "generate unlock key": "Gerar chave de desbloqueio",
            "generate unlock key description": "Digite o “Código de bloqueio” do dispositivo do TCT no campo abaixo. Pressione o botão “Gerar” para gerar uma chave de desbloqueio e use-a no TCT para desbloquear seu dispositivo.",
            "invalid lock code": "Código de bloqueio do dispositivo inválido.",
            "limit reached": "Você atingiu o número máximo de chaves de desbloqueio geradas.",
            "lock code": "Código de bloqueio",
            "select device platform": "Selecione a plataforma do dispositivo",
            "select device platform description": "Selecione a plataforma de dispositivo correta. Os dispositivos telemáticos são categorizados em três gerações de plataformas: <1>FT</1> (FTx, ATx), <2>FMx</2> (vários modelos FM, FMT, TAT, MSP, TFT, TST, GH e TMT) e <3>Legacy</3> (modelos FM, FMA e GH mais antigos).",
            "unlock key": "Chave de desbloqueio",
            "unlock key success message": "Chave de desbloqueio gerada com sucesso."
        },
        "upload file": "Carregar arquivo",
        "upload file description": "Carregue até {{count}} arquivos de uma vez usando o campo de arrastar e soltar ou selecionando-os.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "As versões de firmware 04.00.00 e superiores incluem proteção contra downgrade. Para obter mais detalhes sobre as alterações no firmware, consulte nossa documentação em <1>Teltonika GPS Wiki</1>. Ao clicar no botão “Avançar”, você concorda e compreende as informações acima.",
        "upload firmware unsupported info": "A atualização para esta versão não está disponível. Entre em contato com o suporte da Teltonika ou com seu gerente de vendas da Teltonika.",
        "use at least one filter": "Use pelo menos um filtro",
        "user": "Usuário",
        "valid until": "Válido até",
        "valid until date disable description": "Este campo só pode ser alterado quando o período de tempo estiver definido como “Personalizado”",
        "vehicle model": "Modelo"
    },
    "Dropzone": {
        "add file": "Adicionar arquivo",
        "add files": "Adicionar arquivos",
        "drop file to upload": "Arraste o arquivo para fazer o upload",
        "drop files to upload": "Arraste os arquivos para fazer o upload",
        "error uploading the file": "Ocorreu um erro ao fazer o upload do arquivo",
        "file invalid type": "Tipo de arquivo inválido selecionado.",
        "file successfully uploaded": "Arquivo carregado com sucesso",
        "file syntax": "A sintaxe do arquivo é a seguinte:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "O limite máximo de arquivos foi atingido.",
        "only one file can be attached": "Apenas um arquivo pode ser anexado.",
        "or drop file to upload": "Ou solte o arquivo para fazer o upload",
        "or drop files to upload": "Ou solte os arquivos para fazer o upload",
        "rows detected": "Linhas no arquivo detectadas com sucesso",
        "select file": "Selecione o arquivo",
        "select files": "Selecione os arquivos",
        "select file type": "Selecione primeiro o tipo de arquivo.",
        "supported formats": "Formatos suportados",
        "too long file name": "O nome do arquivo é muito longo. O máximo permitido é {{maxLength}} caracteres.",
        "too many files description": "Os demais arquivos podem ser enviados após o envio dos arquivos selecionados.",
        "too many files title": "Há um limite máximo de {{maxFiles}} arquivos que você pode anexar de uma vez."
    },
    "Error": {
        "error": "Erro",
        "message wait": "Aguarde até que o erro seja corrigido.",
        "title": "Ocorreu um problema!"
    },
    "Feature highlight": {
        "got it": "Entendi",
        "new feature": "Novo recurso!",
        "scenarios description": "Agora, você pode definir um dos seguintes cenários no seu dispositivo: excesso de velocidade, detecção de colisão ou detecção de reboque."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Status",
        "all permissions": "Todas as permissões",
        "batch_id": "ID do lote",
        "company_id": "Empresa",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Criado por",
        "current_configuration": "Configuração",
        "current_firmware": "Firmware",
        "device_imei": "IMEI do dispositivo",
        "file type": "Tipo de arquivo",
        "filtered by": "Filtrado por",
        "filters used": "Filtros utilizados",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Grupo",
        "id": "ID",
        "Invalid company": "Empresa inválida",
        "model": "Modelo",
        "model_platform": "Plataforma",
        "Multiple companies": "Várias empresas",
        "parent company": "Empresa controladora",
        "permission": "Permissão",
        "permission status": "Status",
        "role": "Função",
        "spec_id": "Spec ID",
        "status_id": "Status",
        "supported_task_type": "Tipo de tarefa",
        "table filters": "Filtros de tabela",
        "task type": "Tipo de tarefa",
        "task_queue": "Fila",
        "type": "Tipo",
        "user status": "Status"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "O tamanho do arquivo do firmware ADAS não pode ser zero.",
        "ADAS firmware is invalid.": "O firmware ADAS é inválido.",
        "All notifications were deleted.": "Todas as notificações foram excluídas.",
        "All notifications were marked as read.": "Todas as notificações foram marcadas como lidas.",
        "At least one user role must be provided.": "É necessário fornecer pelo menos uma função de usuário.",
        "Attributes length is invalid": "O comprimento dos atributos é inválido.",
        "Banner was updated.": "",
        "Batch was discarded": "O lote foi descartado.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Foi criada uma tarefa de atualização em massa de atributos. Os atributos dos dispositivos serão atualizados em breve.",
        "Bulk create job was created. Devices will be created shortly.": "Foi criada uma tarefa de criação em massa. Os dispositivos serão criados em breve.",
        "Bulk create job was created. Tasks will be created shortly.": "A tarefa de criação em massa foi criada. As tarefas serão criadas em breve.",
        "Bulk delete job was created. Companies will be removed shortly.": "Foi criada uma tarefa de exclusão em massa. As empresas serão removidas em breve.",
        "Bulk delete job was created. Devices will be removed shortly.": "Foi criada uma tarefa de exclusão em massa. Os dispositivos serão removidos em breve.",
        "Bulk delete job was created. Files will be removed shortly.": "Foi criada uma tarefa de eliminação em massa. Os ficheiros serão removidos em breve.",
        "Bulk delete job was created. Groups will be removed shortly.": "Foi criada uma tarefa de eliminação em massa. Os grupos serão removidos em breve.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Foi criada uma tarefa de eliminação em massa. Os códigos dos produtos serão removidos em breve.",
        "Bulk delete job was created. Users will be removed shortly.": "Foi criada uma tarefa de eliminação em massa. Os usuários serão removidos em breve.",
        "Bulk task create job was created. Tasks will be created shortly.": "A tarefa em massa foi criada e as tarefas aparecerão em breve. As tarefas podem ser encontradas na página “Grupos de tarefas”, em Detalhes do grupo de tarefas.",
        "Bulk update job was created. Devices will be updated shortly.": "Foi criada uma tarefa de atualização em massa. Os dispositivos serão atualizados em breve.",
        "Bulk update job was created. Tasks will be updated shortly.": "Foi criada uma tarefa de atualização em massa. As tarefas serão atualizadas em breve.",
        "Can adapter was added.": "Foi adicionado um adaptador.",
        "Can adapter was deleted.": "O adaptador pode ter sido excluído.",
        "Can adapter was updated.": "O adaptador Can foi atualizado.",
        "Can chip firmware file size can't be zero": "O tamanho do arquivo do firmware do chip não pode ser zero.",
        "Can chip firmware is invalid.": "O firmware do chip pode estar inválido.",
        "Cannot delete company. Company is not empty.": "Não é possível excluir a empresa. A empresa não está vazia.",
        "Cannot delete file. It is used by pending or running tasks.": "Não é possível excluir o arquivo. Ele é usado para tarefas pendentes ou em execução.",
        "Cannot delete file. It is used by running tasks.": "Não é possível excluir o arquivo. Ele é usado por tarefas em execução.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Não é possível excluir o código do produto atribuído aos dispositivos.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Limite de empresas excedido.",
        "Companies in the request must belong to the selected root.": "As empresas na solicitação devem pertencer à raiz selecionada.",
        "Company merge job was created. It will be merged shortly.": "A tarefa de fusão da empresa foi criada. A fusão será realizada em breve.",
        "Company name already exist.": "O nome da empresa já existe.",
        "Company level change is not allowed.": "Não é permitida a alteração do nível da empresa.",
        "Company level successfully changed": "Nível da empresa alterado com sucesso.",
        "company level successfully reverted": "O nível da empresa foi revertido com sucesso para o nível atribuído automaticamente.",
        "Company not allowed to be merged": "A empresa não pode ser incorporada.",
        "company resource limits changed": "Limites de recursos da empresa alterados com sucesso.",
        "Company was created.": "A empresa foi criada.",
        "Company was deleted.": "A empresa foi excluída.",
        "Company was updated.": "A empresa foi atualizada.",
        "compatibilities added": "{{count}} novas compatibilidades adicionadas durante a sincronização.",
        "compatibilities synchronized": "Compatibilidades ausentes sincronizadas com sucesso.",
        "Configuration cannot have FOTA functionality disabled": "A configuração não pode ter a funcionalidade FOTA desativada.",
        "Configuration file cannot contain duplicate parameters": "O arquivo de configuração não pode conter parâmetros duplicados.",
        "Configuration file size can't be zero": "O tamanho do arquivo de configuração não pode ser zero.",
        "Configuration files count limit exceeded.": "Limite de contagem de arquivos de configuração excedido.",
        "Configuration version must be defined": "A versão da configuração deve ser definida.",
        "custom resource limits successfully reverted": "Limites de recursos personalizados revertidos com sucesso para limites atribuídos automaticamente.",
        "Custom roles feature is not enabled.": "O recurso de funções personalizadas só pode ser usado por usuários com nível Premium da empresa. As funções personalizadas criadas anteriormente podem ser excluídas.",
        "desktop license added": "A licença de desktop “{{name}}” foi adicionada com sucesso.",
        "Devices already are in target company": "Os dispositivos já estão na empresa-alvo.",
        "Device already exists.": "O dispositivo já existe.",
        "Device bulk attribute update file cannot be empty": "O arquivo de atualização em massa dos atributos do dispositivo não pode estar vazio.",
        "Device bulk attribute update file should be .csv": "O arquivo de atualização em massa dos atributos do dispositivo deve estar no formato .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Limite de exportação de dispositivos atingido. Não é possível exportar mais de 100.000 dispositivos.",
        "Device import limit reached. You can not import more than 100 devices": "Limite de importação de dispositivos atingido. Não é possível importar mais de 100 dispositivos.",
        "Device model and task type compatibility was updated.": "A compatibilidade entre modelos de dispositivos e tipos de tarefas foi atualizada.",
        "Device model was created.": "O modelo do dispositivo foi criado.",
        "Device model was deleted.": "O modelo do dispositivo foi excluído.",
        "Device model was updated.": "O modelo do dispositivo foi atualizado.",
        "Device not found": "Dispositivo não encontrado.",
        "Device Transfer job was created. Devices will be transfered shortly.": "A tarefa de transferência de dispositivos foi criada. Os dispositivos serão transferidos em breve.",
        "Device was added.": "Dispositivo adicionado.",
        "Device was deleted.": "O dispositivo foi excluído.",
        "Device was updated.": "O dispositivo foi atualizado.",
        "Email or password is incorrect.": "O e-mail ou a senha que você inseriu está incorreto.",
        "Failed to create Product code": "Falha ao criar código do produto.",
        "Failed to delete Product code": "Falha ao excluir o código do produto.",
        "Failed to import devices.": "Falha ao importar dispositivos.",
        "Failed to Read Product code": "Falha ao ler o código do produto.",
        "Failed to retry failed tasks": "Falha ao tentar novamente tarefas com falha.",
        "Failed to update Product code": "Falha ao atualizar o código do produto.",
        "Failed to update task for retry": "Falha ao tentar novamente a tarefa que falhou.",
        "Field is not valid": "O campo não é válido.",
        "File description is too long. Max 255 characters allowed.": "A descrição do arquivo é muito longa. O máximo permitido é 255 caracteres.",
        "File exceeds entries limit of 10000.": "O arquivo excede o limite de entrada de 10.000.",
        "File must not contain duplicated IMEIs": "O arquivo não deve conter IMEIs duplicados.",
        "File must not contain IMEIs that already exist in database.": "O arquivo não deve conter IMEIs que já existam no banco de dados.",
        "File must not contain invalid IMEIs": "O arquivo não deve conter IMEIs inválidos.",
        "File name is too long. Max 255 characters allowed.": "O nome do arquivo é muito longo. São permitidos no máximo 255 caracteres.",
        "File name should not contain illegal characters or symbols": "O nome do arquivo não pode conter caracteres especiais.",
        "File not found": "Arquivo não encontrado.",
        "File was deleted.": "O arquivo foi excluído.",
        "File was successfully uploaded.": "O arquivo foi carregado com sucesso.",
        "File was updated.": "O arquivo foi atualizado.",
        "File was uploaded. Devices will be imported shortly.": "O arquivo foi carregado. Os dispositivos serão importados em breve.",
        "File will be created shortly. Check files in a second.": "O arquivo será criado em breve. Verifique os arquivos em um segundo.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "O tamanho do arquivo do firmware não pode ser zero.",
        "First device in file not found.": "Primeiro dispositivo no arquivo não encontrado.",
        "Forbidden": "Proibido.",
        "Group name already exist.": "O nome do grupo já existe.",
        "Group was added.": "“{{group}}” criado com sucesso.",
        "Group was created.": "Grupo criado.",
        "Group was deleted.": "O grupo foi excluído.",
        "Group was updated.": "O grupo foi atualizado.",
        "Invalid device bulk update attribute": "Atributo de atualização em massa de dispositivo inválido.",
        "Invalid email address.": "Endereço de e-mail inválido.",
        "Invalid file contents": "Conteúdo do arquivo inválido.",
        "Invalid file name": "Nome de arquivo inválido.",
        "Invalid invitation token.": "Token de convite inválido.",
        "Invalid token": "Token inválido.",
        "Invalid token length": "Comprimento do token inválido.",
        "Internal Server Error": "Erro interno do servidor.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "A licença foi excluída.",
        "License was updated.": "A licença foi atualizada.",
        "Maximum companies hierarchy depth exceeded": "Profundidade máxima da hierarquia da empresa excedida",
        "Maximum device group size exceeded.": "Tamanho máximo do grupo de dispositivos excedido.",
        "Method Not Allowed": "Método não permitido.",
        "Network Error": "Erro de rede.",
        "No changes made": "Nenhuma alteração foi feita.",
        "No resources found.": "Nenhum recurso encontrado.",
        "not allowed to affect batch": {
            "description": "Certifique-se de que controla a empresa do utilizador que criou este grupo de tarefas.",
            "title": {
                "approve": "Você não tem permissão para aprovar este lote.",
                "discard": "Você não tem permissão para descartar este lote."
            }
        },
        "Not Found": "Não encontrado.",
        "Notification was deleted.": "A notificação foi excluída.",
        "notify when done title": "Isso pode demorar um pouco. Pressione o botão abaixo para fechar esta tela e você receberá uma notificação quando terminar.",
        "Obd record was created.": "O registro OBD foi criado.",
        "Obd record was updated.": "O registro OBD foi atualizado.",
        "offline license added": "A licença offline “{{name}}” foi adicionada com sucesso.",
        "Offline license was deleted.": "A licença offline foi excluída.",
        "Only id_list source is supported.": "Apenas a fonte id_list é suportada.",
        "Only users with Teltonika email can be invited into internal companies.": "Apenas usuários com e-mail Teltonika podem ser convidados para empresas internas.",
        "Only users with Teltonika email can be moved into internal companies.": "Apenas usuários com e-mail Teltonika podem ser transferidos para empresas internas.",
        "Parent company cannot be a descendant of the updated company.": "A empresa matriz não pode ser descendente da empresa atualizada.",
        "Password reset link was sent to Your email.": "O link para redefinir a senha foi enviado para o seu e-mail.",
        "Password reset token is invalid, expired or related user no longer exists.": "O token de redefinição de senha é inválido, expirou ou o usuário não existe mais.",
        "Password was changed.": "A senha foi alterada.",
        "product code added": "O código do produto “{{code}}” foi adicionado com sucesso.",
        "Product code is too long. Max 200 characters allowed.": "O código do produto é muito longo. São permitidos no máximo 200 caracteres.",
        "ProductCode already exists.": "O código do produto já existe.",
        "ProductCode not found": "Código do produto não encontrado.",
        "Product code was deleted.": "O código do produto foi excluído.",
        "Product code was updated.": "O código do produto foi atualizado.",
        "Retry failed tasks job was created": "A tarefa de repetir as tarefas com falha foi criada.",
        "Role cannot be set for an internal user.": "Não é possível definir funções para usuários internos.",
        "Role was created.": "A função foi criada.",
        "Role was deleted.": "A função foi excluída.",
        "Role was updated.": "A função foi atualizada.",
        "selected company changed": "A empresa selecionada foi alterada.",
        "Selected firmware bundle is not supported by the device.": "O pacote de firmware selecionado não é compatível com o dispositivo.",
        "Server Error": "Erro do servidor.",
        "SMS was sent.": "SMS enviado.",
        "Something went wrong while saving a new password.": "Ocorreu um problema ao salvar uma nova senha.",
        "Successfully logged out.": "Sessão encerrada com sucesso.",
        "System Admin user level is required in order to perform this action.": "É necessário ter nível de usuário de administrador do sistema para realizar esta ação.",
        "Target company cannot be a descendant of source company.": "A empresa de destino não pode ser descendente da empresa de origem.",
        "Task create limit exceeded.": "Não é possível criar um grupo de tarefas para mais de 100.000 dispositivos.",
        "Task type is not retriable": "O tipo de tarefa não é repetível",
        "Task was added.": "Tarefa adicionada.",
        "task was created": "A tarefa foi criada para {{imei}} (“{{taskType}}”). A tarefa pode ser encontrada na página “Dispositivos”, em “Tarefas”, nos detalhes do dispositivo.",
        "Task was updated.": "A tarefa foi atualizada.",
        "Tasks were approved": "As tarefas foram aprovadas.",
        "The given data was invalid.": "Os dados fornecidos eram inválidos.",
        "time zone changed": "O fuso horário foi alterado.",
        "Token cannot be null or empty": "O token não pode ser nulo ou vazio.",
        "token created": "O token da API foi criado com sucesso.",
        "Token has expired": "O token expirou.",
        "Token's and token's owner companies do not match": "Os tokens e as empresas proprietárias dos tokens não correspondem.",
        "Token was deleted.": "O token foi excluído.",
        "Too many resources in the request": "Recursos excessivos na solicitação",
        "Too Many Requests": "Demasiadas solicitações.",
        "Transfer token created": "Token de transferência criado.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "A autenticação de dois fatores já está ativada para o usuário.",
        "Two factor authentication successfully disabled.": "Autenticação de dois fatores desativada com sucesso.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Não é possível enviar SMS. Este dispositivo não tem um número GSM atribuído.",
        "Unable to validate Your request.": "Não foi possível validar sua solicitação.",
        "Unauthenticated.": "Não autenticado.",
        "Unauthorized": "Não autorizado.",
        "User access level is not valid": "O nível de acesso do usuário não é válido",
        "User invitation was revoked": "Convite cancelado com sucesso.",
        "User invitation was re-sent": "O convite do usuário foi reenviado.",
        "User is already in the system.": "O usuário já está no sistema.",
        "User was created.": "O usuário foi criado.",
        "User was deleted.": "O usuário foi excluído.",
        "User was invited.": "Convite do usuário enviado com sucesso.",
        "User was updated": "O usuário foi atualizado.",
        "Users count limit exceeded.": "Limite de usuários excedido.",
        "Your password has been changed.": "Sua senha foi alterada."
    },
    "General": {
        "0": "Usuário",
        "5": "Suporte",
        "10": "Admin",
        "15": "Gerente administrativo",
        "19": "",
        "20": "Usuário do sistema",
        "99": "Superusuário",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Criação da empresa",
        "Company.Delete": "Exclusão da empresa",
        "Company.Merge": "Fusão de empresas",
        "Company.Update": "Atualização da empresa",
        "Device.Export": "Exportação de dispositivos",
        "Device.Read": "Leitura de dispositivos",
        "Device.SecretsRead": "",
        "Device.Transfer": "Transferência de dispositivos",
        "Device.Unlock": "Desbloqueio de dispositivos",
        "Device.Update": "Atualização de dispositivos",
        "DeviceGroup.Create": "Criação de grupos de dispositivos",
        "DeviceGroup.Delete": "Exclusão de grupos de dispositivos",
        "DeviceGroup.Read": "Leitura de grupo de dispositivos",
        "DeviceGroup.Update": "Atualização do grupo de dispositivos",
        "File.Create": "Criação de arquivos",
        "File.Delete": "Exclusão de arquivos",
        "File.Download": "Download de arquivos",
        "File.Read": "Leitura de arquivos",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Atualização de arquivos",
        "Role.Create": "Criação de funções",
        "Role.Delete": "Exclusão de função",
        "Role.Read": "Função de leitura",
        "Role.Update": "Atualização de função",
        "Task.Create": "Criação de tarefas",
        "Task.Read": "Tarefa lida",
        "Task.Retry": "Reentrada de tarefas",
        "Task.Update": "Atualização de tarefas",
        "TaskGroup.Read": "Leitura de grupo de tarefas",
        "TctIntegration.Access": "Integração TCT",
        "Token.Create": "Criação de tokens",
        "Token.Delete": "Exclusão de token",
        "Token.Read": "Leitura de token",
        "User.Create": "",
        "User.Delete": "Exclusão de usuários",
        "User.Read": "Leitura do usuário",
        "User.Update": "Atualização do usuário",
        "--- END-OF-PERMISSIONS ---": "",
        "1-wire authorization list": "Lista de autorizações 1-Wire",
        "1_wire_authorization_list": "Lista de autorizações 1-Wire",
        "Active": "Ativo",
        "adas_firmware": "Firmware ADAS",
        "apx_firmware": "Firmware APX",
        "assign can package": "Atribuir pacote CAN",
        "assigned package": "Pacote atribuído",
        "automatic": "Automático",
        "banner management": "",
        "batches": "Grupos de tarefas",
        "black_box": "Caixa preta",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "blue_nrg": "Firmware BlueNRG",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Lista de autorizações Bluetooth",
        "bluetooth_authorization_list": "Lista de autorizações Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Incompatível",
                "true": "Compatível"
            },
            "web_editor_support": {
                "false": "TCT web não suportado",
                "true": "Compatível com a TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Nome do adaptador CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Configuração OEM",
        "can_debug_log": "Registro de depuração CAN",
        "can oem file package": "Pacote de arquivos OEM",
        "can oem file vehicle": "Veículo de arquivos OEM",
        "can package": "Pacote OEM",
        "can program number": "Número do programa CAN",
        "can revision": "Revisão CAN",
        "can software date": "Dados do software CAN",
        "can type": "Tipo CAN",
        "Cancelled": "Cancelado",
        "cancel task": "Cancelar tarefa",
        "can_chip_firmware": "Firmware do chip FM CAN",
        "carrier_advance_firmware": "Firmware Carrier Advance",
        "carrier_advance_settings": "Configurações de Carrier Advance",
        "carrier_apx_firmware": "Firmware Carrier APX",
        "carrier_apx_settings": "Configurações do Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Arquivos do registrador de temperatura da Carrier",
        "certificate": "Certificado",
        "click for more details": "Clique para obter mais detalhes",
        "client ip": "IP do cliente",
        "clone model": "Clonar modelo de dispositivo",
        "collapse menu": "Recolher menu",
        "companies": "Empresas",
        "company": "Empresa",
        "company level": "Nível da empresa",
        "company type": "Tipo de empresa",
        "company name": "Nome da empresa",
        "Completed": "Concluído",
        "Completed with errors": "Concluído com erros",
        "configuration": "Configuração",
        "configuration_36": "Configuração (FM36)",
        "configuration_64": "Configuração (FMB64)",
        "crash_dump": "Registro de despejo de memória",
        "created at": "Criado em",
        "created by": "Criado por",
        "custom": "Personalizado",
        "custom resource limits": "Limites de recursos personalizados",
        "dashboard": "Painel de controle",
        "delete desktop license": "Excluir licença de desktop",
        "delete offline license": "Excluir licença offline",
        "desktopLicenses": "Licenças para desktop",
        "device_export_file_csv": "Arquivo de exportação do dispositivo (.csv)",
        "device_export_file_xlsx": "Arquivo de exportação do dispositivo (.xlsx)",
        "deviceModels": "Modelos",
        "deviceModelTaskCompatibilities": "Compatibilidades",
        "device_transfer_report": "Relatório de transferência de dispositivos",
        "device group": "Grupo",
        "DeviceImportFile": "Arquivo de importação de dispositivos",
        "devices": "Dispositivos",
        "download file": "Baixar arquivo",
        "download offline license": "Baixe a licença offline",
        "dsm_firmware": "Firmware DSM",
        "dtb": "DTB",
        "edit compatibility": "Editar compatibilidade do dispositivo",
        "edit model": "Editar modelo do dispositivo",
        "edit company": "Editar empresa",
        "edit desktop license": "Editar licença para desktop",
        "edit device": "Editar dispositivo",
        "edit file": "Editar arquivo",
        "edit group": "Editar grupo",
        "edit in tct web": "Editar na TCT web",
        "edit in tct web disabled": "A edição na TCT web está disponível apenas para o nível Premium da empresa.",
        "edit product code": "Editar código do produto",
        "edit role": "Editar função",
        "edit smart group": "Editar Grupo Inteligente",
        "edit user": "Editar usuário",
        "Empty": "Vazio",
        "enter here": "Entre aqui",
        "exception_info": "Informações sobre exceções",
        "Executing": "Executando",
        "expand menu": "Expandir menu",
        "Expired": "Expirado",
        "Factory": "",
        "Failed": "Falha",
        "file": "Arquivo",
        "file data": "Dados de arquivos",
        "files": "Arquivos",
        "file deleted": "O arquivo foi excluído",
        "firmware": "Firmware",
        "firmware_36": "Firmware (FM36)",
        "firmware_64": "Firmware (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Pacote de firmware",
        "fw_bundle_ble": "Pacote - Firmware BLE",
        "fw_bundle_ble_dtb": "Pacote - BLE DTB",
        "fw_bundle_can": "Pacote - Firmware CAN",
        "fw_bundle_can_dtb": "Pacote - CAN DTB",
        "fw_bundle_dtb": "Pacote - DTB principal",
        "fw_bundle_mainfw": "Pacote - Firmware principal",
        "generic": "",
        "global_configuration": "Configuração global",
        "global_firmware": "Firmware global",
        "gnssm_download_assistant": "Assistente de download GNSS-M",
        "gnssm_firmware": "Firmware GNSS-M",
        "group": "Grupo",
        "groups": "Grupos de dispositivos",
        "hardware key": "Chave de hardware",
        "id": "ID",
        "id_collection_file": "Arquivo de coleta de identificação",
        "imei restriction": "Restrição IMEI",
        "Inactive": "Inativo",
        "Invalid": "Inválido",
        "invalid model": "Modelo inválido",
        "invalid model_name": "Modelo inválido",
        "InvitationExpired": "Convite expirado",
        "InvitationPending": "Convite pendente",
        "Legacy": "Legado",
        "legacy model": "Modelo legado",
        "legacy model_platform": "Plataforma legada",
        "legacy platform": "Plataforma legada",
        "license has expired": "A licença expirou",
        "loading": "Carregando",
        "log": "Registro",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Manual",
        "ManualGeofenceList": "",
        "manual geofence list": "Lista de cenários de geofence manual",
        "manual_geofence_list": "Lista de cenários de geofence manual",
        "meig_modem_firmware": "Firmware do modem MeiG",
        "menu": "Menu",
        "modem version": "Versão modem",
        "netprisma_modem_firmware": "Firmware do modem NETPRISMA",
        "nmea_log": "Registro NMEA",
        "no": "Não",
        "no results": "Nenhum resultado inicial encontrado",
        "no results description": "Assim que {{name}} forem carregados no FOTA WEB, você poderá ver os dados aqui",
        "not assigned": "Não atribuído",
        "not assigned configuration_file_id": "Configuração não atribuída",
        "not assigned current_configuration": "Configuração não atribuída",
        "not assigned current_firmware": "Firmware não atribuído",
        "not assigned firmware_file_id": "Firmware não atribuído",
        "not assigned group_id": "Grupo não atribuído",
        "not assigned model": "Modelo não atribuído",
        "not assigned spec_id": "Spec ID não atribuído",
        "not assigned task_type": "Tipo de tarefa não atribuído",
        "obd_chip_firmware": "Firmware do chip FM OBD",
        "obd chip firmware version": "Versão do firmware do chip OBD",
        "Offline": "Offline",
        "offline licenses": "Licenças offline",
        "Online": "Online",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "ou",
        "other": "Outros",
        "Pending": "Pendente",
        "Pending approval": "Aguardando aprovação",
        "permission disabled": "Desativado",
        "permission enabled": "Ativado",
        "productCodes": "Códigos de produto",
        "psub": "Arquivo de assinatura",
        "quectel_fw": "Firmware do modem Quectel (quectel_fw)",
        "quectel_modem_firmware": "Firmware do modem Quectel",
        "resend invite": "Reenviar o convite",
        "restricted": "Restrito",
        "retry": "Repetir",
        "roles": "Funções e permissões",
        "Running": "Em execução",
        "RxAutoscan": "Receba arquivos CAN com varredura automática",
        "RxBlackBox": "Receba a caixa preta",
        "RxBluetoothAuthorizationList": "Receba a lista de autorizações Bluetooth",
        "RxCanDebugLog": "Receba o log de depuração CAN",
        "RxCarrierExtractions": "Baixar Carrier extractions",
        "RxCarrierLoggerFiles": "Baixar arquivos do registrador de temperatura da Carrier",
        "RxConfiguration": "Receber configuração",
        "RxCrashDump": "Receba o log de despejo de memória",
        "RxExceptionInfo": "Receba informações sobre exceções",
        "RxLog": "Receba o log interno",
        "RxManualGeofenceList": "Receba uma lista de cenários de geofence manuais",
        "RxNmeaLog": "Receba o registro NMEA",
        "RxOneWireAuthorizationList": "Receba a lista de autorizações 1-Wire",
        "RxWdLog": "Receba o log do watch-dog (WD)",
        "select company": "Selecione a empresa",
        "SetBindSim": "Vincule o dispositivo ao(s) cartão(ões) SIM atual(is)",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Desativar recurso",
        "SetEnableFeature": "Ativar recurso",
        "SetForceLockSim": "Bloqueio forçado do SIM",
        "SetUnbindSim": "Desvincule o dispositivo com cartão(ões) SIM",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Status",
        "task details": "Detalhes da tarefa",
        "task groups": "Grupos de tarefas",
        "tasks": "Grupos de tarefas",
        "tasksCompatibility": "Compatibilidade de tarefas",
        "task type": "Tipo de tarefa",
        "Tct": "",
        "time zone": "Fuso horário",
        "total": "Total",
        "tutorials": "Tutoriais",
        "TxAdasFirmware": "Carregar firmware ADAS",
        "TxAgpsMt3333": "Transferir arquivo AGPSM",
        "TxAgpsQuectelL89": "Transferir arquivo AGPSQ",
        "TxAutoscanCanConfiguration": "Carregar arquivo OEM de varredura automática",
        "TxBleFirmware": "Carregar firmware BLE",
        "TxBlueNrgFirmware": "Carregar firmware BlueNrg",
        "TxBluetoothAuthorizationList": "Carregar lista de autorizações Bluetooth",
        "TxBundleBle": "Carregar firmware BLE",
        "TxBundleBleDtb": "Carregar BLE DTB",
        "TxBundleCan": "Carregar firmware CAN",
        "TxBundleCanDtb": "Carregar CAN DTB",
        "TxBundleDtb": "Carregar DTB principal",
        "TxBundleFirmware": "Carregar firmware principal",
        "TxCanAdapterModeChange": "Alterar o modo do adaptador CAN externo",
        "TxCanAdapterModeChangeInternal": "Alterar o modo do adaptador CAN interno",
        "TxCanAdapterUpdate": "Carregar firmware do adaptador CAN",
        "TxCanAdapterUpdateInternal": "Atualização do adaptador CAN interno",
        "TxCanChipFirmware": "Carregar firmware do chip FMXY50 CAN",
        "TxCanConfiguration": "Carregar arquivo OEM",
        "TxCarrierAdvanceFirmware": "Atualização do firmware Carrier Advance",
        "TxCarrierAdvanceSettings": "Atualizar configurações do Carrier Advance",
        "TxCarrierApxFirmware": "Atualização do firmware Carrier APX",
        "TxCarrierApxSettings": "Atualizar configurações do Carrier APX",
        "TxConfiguration": "Configuração de upload",
        "TxDsmFirmware": "Carregar firmware DSM",
        "TxDtb": "Carregar DTB",
        "TxFirmware": "Carregar firmware",
        "TxFirmwareBundle": "Carregar pacote de firmware",
        "TxFirmwareBundleParts": "Carregar pacote de firmware",
        "TxFotaCertificate": "Atualizar certificado FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Assistente de upload e download GNSS-M",
        "TxGNSSMFirmware": "Carregar firmware GNSS-M",
        "TxManualGeofenceList": "Carregar lista manual de cenários de geofence",
        "TxMeigModemDeltaFirmware": "Carregar firmware do modem MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Carregar firmware do modem NETPRISMA Delta",
        "TxObdChipFirmware": "Atualização do chip OBD",
        "TxObdConfig": "Transferir arquivo de configuração OBD",
        "TxOneWireAuthorizationList": "Carregar lista de autorizações 1-Wire",
        "TxPSub": "Transferir arquivo de assinatura",
        "TxQuectelModemDeltaFirmware": "Carregar firmware do modem Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Carregar certificado TLS do usuário",
        "users": "Usuários",
        "Unknown": "Desconhecido",
        "unknown": "Desconhecido",
        "unknown model_platform": "Plataforma desconhecida",
        "unknown origin": "",
        "unknown platform": "Plataforma desconhecida",
        "unrestricted": "Sem restrições",
        "Verifying": "Verificando",
        "vin": "VIN",
        "vip status": "Status VIP",
        "wd_log": "Registro WD",
        "yes": "Sim"
    },
    "Maintenance": {
        "title": "Aguarde! Estamos em manutenção."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} falhou devido a um erro do servidor.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para cancelar todas as tarefas selecionadas. Algumas tarefas estão associadas a recursos de diferentes empresas.",
            "Cancel tasks action failed. No resources found.": "Nenhuma tarefa correspondeu à sua seleção. Revise sua seleção de tarefas e tente novamente.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "A empresa “{{SourceCompanyName}}” ({{SourceCompanyId}}) foi incorporada pela “{{TargetCompanyName}}” ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Falha na fusão de empresas. As empresas \"{{SourceCompanyId}}\" e \"{{TargetCompanyId}}\" não podem ser fusionadas devido a configurações ou permissões incompatíveis.",
            "Create device group tasks action failed. No resources found.": "Falha ao criar tarefas para o Smart Group. Tente reatribuir o arquivo.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} tarefa(s) criada(s) para dispositivos do grupo de dispositivos ID:{{GroupId}}.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para criar tarefas para todos os dispositivos selecionados. Alguns dispositivos pertencem a empresas diferentes.",
            "Create tasks action failed. No resources found.": "Nenhum dispositivo correspondeu à sua seleção. Revise sua seleção de dispositivos e tente novamente.",
            "Create tasks action failed. No resources processed.": "Falha ao processar os dispositivos selecionados. Tente criar o grupo de tarefas novamente.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para excluir todas as empresas selecionadas. Algumas empresas não estão sob sua gestão direta.",
            "Delete companies action failed. No resources found.": "Nenhuma empresa correspondeu à sua seleção. Revise sua seleção de empresas e tente novamente.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para excluir todos os arquivos selecionados. Alguns arquivos estão associados a recursos de diferentes empresas.",
            "Delete files action failed. No resources found.": "Nenhum arquivo correspondeu à sua seleção. Revise sua seleção de arquivos e tente novamente.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para excluir todos os grupos de dispositivos selecionados. Alguns grupos de dispositivos contêm recursos de diferentes empresas.",
            "Delete groups action failed. No resources found.": "Nenhum grupo de dispositivos correspondeu à sua seleção. Revise sua seleção de grupos de dispositivos e tente novamente.",
            "Delete product codes action failed. No resources found.": "Nenhum código de produto correspondeu à sua seleção. Revise sua seleção de códigos de produto e tente novamente.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para excluir todos os usuários selecionados. Alguns usuários pertencem a empresas diferentes.",
            "Delete users action failed. No resources found.": "Nenhum usuário correspondeu à sua seleção. Revise sua seleção de usuários e tente novamente.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} dispositivo(s) exportado(s) para “{{Filename}}”.",
            "{{DevicesCount}} device(s) imported.": "{{DevicesCount}} dispositivo(s) importado(s).",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "{{DevicesProcessedCount}} dispositivo(s) processado(s), {{TasksCreatedCount}} tarefa(s) criada(s).",
            "Export devices action failed. No resources found.": "Nenhum dispositivo correspondeu à sua seleção. Revise sua seleção de dispositivos e tente novamente.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} tarefa(s) retornou(ram) para pendente no grupo de tarefas {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Escopo de solicitação inválido. Os recursos devem pertencer a uma única raiz.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "{{ProcessedCount}} empresas excluídas.",
            "{{ProcessedCount}} device group(s) deleted.": "{{ProcessedCount}} grupo(s) de dispositivos excluído(s).",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} atributos do dispositivo atualizados.",
            "{{ProcessedCount}} device model(s) deleted.": "{{ProcessedCount}} modelo(s) de dispositivo(s) excluído(s).",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} dispositivo(s) atualizado(s).",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} arquivo(s) excluído(s).",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} códigos de produto excluídos.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} tarefa(s) cancelada(s).",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} tarefa(s) atualizada(s).",
            "{{ProcessedCount}} user(s) deleted.": "{{ProcessedCount}} usuário(s) excluído(s).",
            "Retry tasks action failed. No resources found.": "Nenhuma tarefa correspondeu à sua seleção. Revise sua seleção de tarefas e tente novamente.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para transferir todos os dispositivos selecionados. Alguns dispositivos pertencem a empresas diferentes.",
            "Transfer devices action failed. No resources found.": "Nenhum dispositivo correspondeu à sua seleção. Revise sua seleção de dispositivos e tente novamente.",
            "Transfer devices action failed. No resources processed.": "Falha ao processar os dispositivos selecionados. Tente transferir os dispositivos novamente.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} de {{TotalDevicesToTransfer}} dispositivos transferidos.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para atualizar todos os dispositivos selecionados. Alguns dispositivos pertencem a empresas diferentes.",
            "Update devices action failed. No resources found.": "Nenhum dispositivo correspondeu à sua seleção. Revise sua seleção de dispositivos e tente novamente.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para atualizar os atributos de todos os dispositivos selecionados. Alguns dispositivos pertencem a empresas diferentes.",
            "Update devices attributes action failed. No resources found.": "Nenhum dispositivo correspondeu à sua seleção. Revise sua seleção de dispositivos e tente novamente.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Você não tem permissão para atualizar todas as tarefas selecionadas. Algumas tarefas estão associadas a recursos de diferentes empresas.",
            "Update tasks action failed. No resources found.": "Nenhuma tarefa correspondeu à sua seleção. Revise sua seleção de tarefas e tente novamente.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Sem notificações",
        "notifications": "Notificações",
        "notifications will be listed": "Todas as novas notificações serão listadas aqui",
        "remove notification": "Remover notificação",
        "see previous notifications": "Ver notificações anteriores",
        "timestamps": {
            "days ago": "{{days}} dias atrás",
            "hours ago": "{{hours}}h atrás",
            "minutes ago": "{{minutes}} min atrás",
            "moments ago": "Há poucos instantes"
        },
        "title": {
            "BackgroundActionFailed": "Ação falhou",
            "CompaniesSuccessfullyDeleted": "Empresas excluídas com sucesso",
            "CompanyBulkDeleteFailed": "Ocorreu um erro ao excluir empresas",
            "CompanyLevelChanged": "Nível da empresa alterado",
            "CompanyLevelDowngradeReminder": "Próximo downgrade ao nível da empresa",
            "CompanyMergeFailed": "Ocorreu um erro ao mesclar empresas",
            "CompanySuccessfullyMerged": "Empresas que se fundiram com sucesso",
            "DeviceAttributesSuccessfullyUpdated": "Atributos do dispositivo atualizados com sucesso",
            "DeviceBulkAttributeUpdateFailed": "Ocorreu um erro ao atualizar os atributos do dispositivo",
            "DeviceBulkUpdateFailed": "Ocorreu um erro durante a atualização dos dispositivos",
            "DeviceExportFailed": "Ocorreu um erro durante a exportação dos dispositivos",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Grupos de dispositivos excluídos com sucesso",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Ocorreu um erro ao criar tarefas do Smart Group",
            "DeviceGroupTasksSuccessfullyCreated": "Tarefas do Smart Group criadas com sucesso",
            "DeviceModelBulkDeleteFailed": "Ocorreu um erro ao excluir modelos de dispositivos",
            "DeviceModelsSuccessfullyDeleted": "Modelos de dispositivos excluídos com sucesso",
            "DevicesSuccessfullyTransferred": "Dispositivos transferidos com sucesso",
            "DevicesSuccessfullyUpdated": "Dispositivos atualizados com sucesso",
            "DeviceTransferFailed": "Ocorreu um erro durante a transferência dos dispositivos",
            "ExportFailed": "Falha na exportação de recursos",
            "ExportSucceeded": "Dispositivos exportados com sucesso",
            "FailedTasksRetryFailed": "Ocorreu um erro ao tentar novamente as tarefas",
            "FailedTasksSuccessfullyRetried": "Tarefas repetidas com sucesso",
            "FileBulkDeleteFailed": "Ocorreu um erro ao excluir arquivos",
            "FilesSuccessfullyDeleted": "Arquivos excluídos com sucesso",
            "GroupBulkDeleteFailed": "Ocorreu um erro ao excluir grupos de dispositivos",
            "ImportFailed": "Falha na importação de recursos",
            "ImportSucceeded": "Dispositivos importados com sucesso",
            "ProductCodeBulkDeleteFailed": "Ocorreu um erro ao excluir os códigos dos produtos",
            "ProductCodesSuccessfullyDeleted": "Códigos de produto excluídos com sucesso",
            "ResourceUpdateFailed": "Falha na atualização do recurso",
            "ResourceUpdateSucceeded": "Atualização de recursos bem-sucedida",
            "RoleBulkDeleteFailed": "Ocorreu um erro ao excluir funções",
            "RolesSuccessfullyDeleted": "Funções excluídas com sucesso",
            "TaskBulkCancelFailed": "Ocorreu um erro ao cancelar tarefas",
            "TaskBulkCreateFailed": "Ocorreu um erro ao criar um grupo de tarefas",
            "TaskBulkUpdateFailed": "Ocorreu um erro durante a atualização das tarefas",
            "TaskGroupSuccessfullyCreated": "Grupo de tarefas criado com sucesso",
            "TasksPropagationFailed": "Falha na tarefa de propagação de tarefas",
            "TasksPropagationSucceeded": "Tarefa de propagação concluída com sucesso",
            "TasksPropagationWarning": "A tarefa de propagação de tarefas foi concluída com avisos",
            "TasksSuccessfullyCanceled": "Tarefas canceladas com sucesso",
            "TasksSuccessfullyUpdated": "Tarefas atualizadas com sucesso",
            "UserBulkDeleteFailed": "Ocorreu um erro ao excluir usuários",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Usuários excluídos com sucesso"
        }
    },
    "Permission actions": {
        "Access": "Integração TCT",
        "Create": "Criar",
        "Delete": "Excluir",
        "Download": "Baixar",
        "Export": "Exportar",
        "Merge": "Mesclar",
        "Read": "Leia",
        "Retry": "Repetir",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Transferência",
        "Unlock": "Desbloquear",
        "Update": "Atualizar"
    },
    "Permission groups": {
        "company": "Empresas",
        "device": "Dispositivos",
        "device group": "Grupos de dispositivos",
        "file": "Arquivos",
        "role": "Funções",
        "task": "Tarefas",
        "task group": "Grupos de tarefas",
        "token": "Tokens",
        "user": "Usuários"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Esta opção está desativada para usuários com nível básico da empresa.",
                "token list": "Os tokens de integração da API estão desativados para usuários com nível básico da empresa."
            },
            "custom_role_support": {
                "create role": "Este recurso só pode ser usado por usuários com nível Premium da empresa.",
                "edit role": "Este recurso só pode ser usado por usuários com nível Premium da empresa. Funções personalizadas criadas anteriormente podem ser excluídas.",
                "edit user": "Este recurso só pode ser usado por usuários com nível Premium da empresa. As funções personalizadas atribuídas anteriormente podem ser removidas."
            },
            "task_schedule_support": {
                "table head": "Este recurso só pode ser usado por usuários com níveis de empresa Standard e Premium. As tarefas adicionadas anteriormente com agendas continuarão a ser executadas."
            }
        },
        "general message": "Este recurso só pode ser usado por usuários com níveis de empresa Standard e Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "Não é possível criar tarefas para mais de {{limitCount}} dispositivos de uma só vez."
        }
    },
    "Search": {
        "code": "Código",
        "description": "Descrição",
        "email": "E-mail",
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "model": "Modelo",
        "name": "Nome",
        "product code": "Código do produto",
        "role name": "Nome da função",
        "serial": "Número de série.",
        "search by": "Pesquisar por",
        "search company name": "Pesquisar nome da empresa"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Você está prestes a desativar sua autenticação de dois fatores. Isso pode tornar sua conta FOTA WEB insegura. Tem certeza de que deseja continuar?",
                    "title": "Tem certeza?"
                },
                "send email code": {
                    "enter code": "Por motivos de segurança, insira o código para verificar o e-mail."
                },
                "send otp code": {
                    "description": "Um código de 6 dígitos foi enviado para o seu aplicativo de autenticação. Por motivos de segurança, insira o código gerado no campo abaixo.",
                    "no access": {
                        "authenticator": "Se você não tiver mais acesso ao aplicativo autenticador vinculado a esta conta, será necessário alterar a senha para desativar a autenticação de dois fatores.",
                        "email": "Se você não tiver mais acesso ao e-mail vinculado a esta conta, será necessário alterar a senha para desativar a autenticação multifatorial."
                    }
                },
                "title": "Desativar autenticação de dois fatores"
            },
            "get email code": {
                "description": "Use esse código na próxima tela para verificar sua conta.",
                "description modal": "Use esse código para verificar sua conta.",
                "title": "Ao clicar em “Enviar código”, um código único será enviado para <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Você precisará de um aplicativo móvel autenticador para concluir este processo, como um dos seguintes:"
            },
            "select authentication type": {
                "authentication app description": "Obtenha um código único em um aplicativo como o Microsoft Authenticator ou o Google Authenticator.",
                "description": "Para manter sua conta e os dados dos clientes seguros, use uma das seguintes opções para configurar a autenticação de dois fatores.",
                "description modal": "Selecione seu método de autenticação preferido.",
                "email": "E-mail",
                "email description": "Enviaremos um código único para o seu e-mail sempre que você tentar fazer login.",
                "recommended": "Recomendado",
                "title": "A autenticação de dois fatores (2FA) é obrigatória para todos os usuários do FOTA WEB.",
                "title modal": "Selecione o método de autenticação"
            },
            "send email code": {
                "description": "Insira o código no campo abaixo e pressione “Verificar” para continuar.",
                "enter code": "Insira o código para verificar o e-mail.",
                "title": "Um código único foi enviado para <1>{{email}}</1>.",
                "verification code": "Código de verificação"
            },
            "send otp code": {
                "click to scan code": "Clique aqui para escanear um código QR",
                "click to type code": "Clique aqui para digitar manualmente o código",
                "incorrect code": "Código incorreto",
                "scan QR code": "Digitalize o código QR no seu aplicativo",
                "six digit code": "Código de 6 dígitos gerado pelo seu aplicativo",
                "title": "Você precisará de um aplicativo móvel autenticador para concluir este processo, como: <1>Microsoft Authenticator</1> ou <2>Google Authenticator</2>.",
                "type text code": "Digite o código de texto no seu aplicativo"
            },
            "settings": {
                "description": "A autenticação de dois fatores é uma camada extra de segurança que verifica sua identidade com algo que você sabe (senha) e algo que você possui (telefone, chave de segurança, e-mail).",
                "disabled": "Desativado",
                "enabled": "Ativado",
                "title": "Autenticação de dois fatores"
            },
            "success message": {
                "alert": "Autenticação de dois fatores ativada com sucesso.",
                "description": "Solicitaremos um código de autenticação sempre que você fizer login com seu e-mail e senha.",
                "title": "Você ativou com sucesso a autenticação de dois fatores.",
                "title modal": "Autenticação de dois fatores ativada!"
            },
            "title": {
                "authentication app": "Aplicativo de autenticação",
                "authentication email": "E-mail de autenticação",
                "is enabled": "Autenticação de dois fatores habilitada.",
                "protect your account": "Proteja sua conta FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Alterar senha",
            "enter current password": "Digite a senha atual",
            "enter new password": "Digite uma nova senha",
            "hide password": "Ocultar senha",
            "repeat new password": "Repita a nova senha",
            "rules": {
                "lowercase letter": "Pelo menos uma letra minúscula (a-z)",
                "minimum characters": "Pelo menos 12 caracteres",
                "new and current passwords must not match": "As senhas novas e atuais não devem ser iguais",
                "new passwords must match": "As novas senhas devem coincidir",
                "number": "Pelo menos um número",
                "passwords must match": "As senhas devem corresponder",
                "special symbol": "Pelo menos um símbolo especial (!@#$%^&*()-_=+)",
                "uppercase letter": "Pelo menos uma letra maiúscula (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Mostrar senha"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Estatísticas da tabela",
        "statistics message": "Os filtros da tabela afetarão as estatísticas que você vê abaixo",
        "activity": "Atividade",
        "model": "Modelo",
        "firmware": "Firmware",
        "configuration": "Configuração",
        "statistics": "Estatísticas"
    },
    "Table": {
        "1_wire_authorization": "Autorização 1-Wire",
        "access group": "",
        "access groups": "",
        "access level": "Nível de acesso",
        "accessories": "Acessórios",
        "action": "Ação",
        "action date": "Data da ação",
        "assigned package": "Pacote atribuído",
        "attempt count": "Contagem de tentativas",
        "attribute": "Atributo",
        "attributes": "Atributos",
        "auto sync": "",
        "batch id": "ID do lote",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Firmware BLE",
        "bluetooth_authorization": "Autorização Bluetooth",
        "bootloader": "Bootloader",
        "can_adapter": "Adaptador CAN",
        "can adapter name": "Nome do adaptador CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Pacote de arquivos OEM",
        "can oem file vehicle": "Veículo de arquivos OEM",
        "can package": "Pacote CAN",
        "can program number": "Número do programa CAN",
        "can software date": "Dados do software CAN",
        "can type": "Tipo CAN",
        "carrier module id": "ID do módulo",
        "carrier revision": "Revisão",
        "carrier serial id": "ID serial",
        "carrier settings filename": "Nome do arquivo de configurações",
        "carrier unit status": "Status",
        "carrier unit type": "Tipo de unidade",
        "changed at": "Alterado em",
        "change origin": "",
        "changes": "Alterações",
        "checkbox disabled": {
            "role": "Funções estáticas não podem ser editadas ou excluídas."
        },
        "child company": "<0>Empresa subsidiária da</0><1>{{parentCompany}}</1>",
        "child companies": "Empresas subsidiárias",
        "code": "Código",
        "company": "Empresa",
        "company hierarchy": "Hierarquia da empresa",
        "company name": "Nome da empresa",
        "compatibility": "Compatibilidade",
        "configuration": "Configuração",
        "configuration details": "Detalhes da configuração do Configurator",
        "configuration type": "",
        "created at": "Criado em",
        "created by": "Criado por",
        "date": "Data",
        "description": "Descrição",
        "device details": "Detalhes do dispositivo",
        "device company": "Empresa de dispositivos",
        "device description": "Descrição do dispositivo",
        "device group": "Grupo de dispositivos",
        "device imei": "IMEI do dispositivo",
        "device model": "Modelo do dispositivo",
        "device seen at": "Dispositivo visto em",
        "device serial": "Número de série do dispositivo.",
        "devices": "Dispositivos",
        "devices count": "Contagem de dispositivos",
        "Done": "Concluído",
        "download at": "",
        "download file": "Baixar arquivo",
        "dtb": "DTB",
        "edit file": "Editar arquivo",
        "edit group banner": "Se um dispositivo for adicionado ao grupo que definiu firmware e/ou configuração, todas as tarefas pendentes anteriores do mesmo tipo serão canceladas.",
        "email": "E-mail",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Assim que os grupos de tarefas forem criados, você poderá ver a lista aqui",
                    "changes": "Assim que as alterações forem feitas, você poderá ver a lista aqui",
                    "companies": "Assim que as empresas forem criadas, você poderá ver a lista aqui",
                    "configurationChanges": "",
                    "desktopLicenses": "Assim que as licenças para desktop forem criadas, você poderá ver a lista aqui",
                    "devices": "Assim que os dispositivos forem carregados no FOTA WEB, você poderá ver a lista aqui",
                    "files": "Assim que os arquivos forem enviados, você poderá ver a lista aqui",
                    "groups": "Assim que os grupos forem criados, você poderá ver a lista aqui",
                    "offlineLicenses": "Assim que as licenças offline forem criadas, você poderá ver a lista aqui",
                    "permissions": "Assim que as permissões forem atribuídas ao usuário, você poderá ver a lista aqui",
                    "productCodes": "Assim que os códigos dos produtos forem criados, você poderá ver a lista aqui",
                    "roles": "Assim que as funções forem criadas, você poderá ver a lista aqui",
                    "tasks": "Assim que as tarefas forem criadas, você poderá ver a lista aqui",
                    "users": "Assim que os usuários forem adicionados, você poderá ver a lista aqui"
                },
                "title": {
                    "batches": "A tabela de grupos de tarefas está vazia",
                    "changes": "A tabela de alterações está vazia",
                    "companies": "A tabela de empresas está vazia",
                    "configurationChanges": "",
                    "desktopLicenses": "A tabela de licenças para desktop está vazia",
                    "devices": "A tabela de dispositivos está vazia",
                    "files": "A tabela de arquivos está vazia",
                    "groups": "A tabela de grupos está vazia",
                    "offlineLicenses": "A tabela de licenças offline está vazia",
                    "permissions": "A tabela de permissões está vazia",
                    "productCodes": "A tabela de códigos de produtos está vazia",
                    "roles": "A tabela de funções está vazia",
                    "tasks": "A tabela de tarefas está vazia",
                    "users": "A tabela de usuários está vazia"
                }
            },
            "no permission": {
                "description": "Entre em contato com seu administrador para solicitar acesso.",
                "title": "Você não tem permissão necessária para visualizar este conteúdo"
            },
            "no results found": {
                "description": "Tente outra palavra-chave ou filtro para obter resultados",
                "title": "Nenhum resultado encontrado"
            },
            "button": {
                "add": {
                    "companies": "Criar empresa",
                    "devices": "Adicionar dispositivo",
                    "files": "Carregar arquivo",
                    "groups": "Criar grupo",
                    "productCodes": "Adicionar código do produto",
                    "tasks": "Criar tarefa",
                    "users": "Convidar usuário"
                },
                "reset view": "Redefinir visualização"
            }
        },
        "exausted autoscan limit": "Limite de varredura automática esgotado até",
        "exausted vin parsing limit": "Limite de análise de VIN esgotado até",
        "expiration": "Expiração",
        "expiration date": "Data de validade",
        "expires at": "Expira em",
        "expiry date": "Data de validade",
        "field": "Campo",
        "file": "Arquivo",
        "file id": "ID do arquivo",
        "files": "Arquivos",
        "file type": "Tipo de arquivo",
        "filter by": "Filtrar por",
        "firmware": "Firmware",
        "general": "Geral",
        "general data": "Dados gerais",
        "gnss version": "Versão GNSS",
        "group": "Grupo",
        "groups": "Grupos de dispositivos",
        "group vip status": "",
        "gsm number": "Número GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": ""
            },
            "platform": {
                "fmx platform": "Plataforma FMx - modelos FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) e TMT.",
                "ft platform": "Plataforma FT - modelos FTx e ATx.",
                "legacy platform": "Plataforma antiga - modelos FM (exceto FM4001 e FM3010), FMA e GH (GH4000).",
                "title": "Geração de plataforma do dispositivo telemático"
            },
            "visibility": "As alterações marcadas como <1>Internas</1> não são visíveis para os clientes. Como as alterações nos dispositivos podem incluir dados visíveis e ocultos, <1>não compartilhe capturas de tela ou detalhes em comunicações externas</1>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Informações",
        "interface": "Interface",
        "invited by": "Convidado por",
        "items": "itens",
        "last checked at": "Última verificação em",
        "last sign in": "Último login",
        "last status update": "Última atualização de status",
        "last used at": "Último uso em",
        "license disabled": "Desativado",
        "license enabled": "Ativado",
        "license key": "Chave de licença",
        "license name": "",
        "links": "Links",
        "manual_geofence_scenarios": "Cenários de geofence manual",
        "message": "Mensagem",
        "model": "Modelo",
        "model task type support": {
            "false": "Não suportado",
            "true": "Compatível"
        },
        "modem version": "Versão modem",
        "name": "Nome",
        "new value": "Novo valor",
        "next task": "Próxima tarefa",
        "no changes": "Sem alterações.",
        "no company name": "Sem nome da empresa",
        "no details": "Sem detalhes",
        "no file": "Sem arquivo",
        "no imei available": "IMEI indisponível",
        "no model": "Sem modelo",
        "no parent company": "A empresa não possui uma empresa controladora.",
        "no tasks": "O dispositivo não tem tarefas.",
        "number": "Número",
        "obd": "OBD",
        "obd chip firmware version": "Versão do firmware do chip OBD",
        "of": "de",
        "offline licenses tab disabled": "As licenças offline não estão disponíveis para licenças de desktop desativadas.",
        "original value": "Valor original",
        "other information": "Outras informações",
        "page of": "página de",
        "parent company": "Empresa controladora",
        "permission count": "Contagem de permissões",
        "platform": "Plataforma",
        "Price": "Preço",
        "product code": "Código do produto",
        "program number": "Número do programa",
        "property": "Propriedade",
        "queue": "Fila",
        "receiving company": "Empresa receptora",
        "revision": "Revisão",
        "role": "Função",
        "role name": "Nome da função",
        "rows per page": "Linhas por página",
        "running": "Em execução",
        "schedule": "Agendar",
        "seen at": "Visto em",
        "select row": "Selecione uma linha para ver os detalhes",
        "send sms": "Enviar SMS",
        "serial": "Número de série.",
        "show details": {
            "desktopLicenses": "Mostrar detalhes da licença para desktop",
            "devices": "Mostrar detalhes do dispositivo",
            "batches": "Mostrar detalhes do grupo de tarefas",
            "tasks": "Mostrar detalhes da tarefa",
            "companies": "Mostrar detalhes da empresa"
        },
        "sim": "SIM",
        "size": "Tamanho",
        "software date": "Data do software",
        "source company": "Empresa de origem",
        "spec_id": "Spec ID",
        "status": "Status",
        "status id": "ID de status",
        "status name": "Nome do status",
        "supported task types": "Tipos de tarefas suportadas",
        "synced at": "",
        "table columns": "Colunas da tabela",
        "target company": "Empresa-alvo",
        "task id": "ID da tarefa",
        "task queue": "Fila de tarefas",
        "tasks": "Tarefas",
        "task type": "Tipo de tarefa",
        "tct web support": "Suporte web TCT",
        "total": "Total",
        "type": "Tipo",
        "updated at": "Atualizado em",
        "updated by": "Atualizado por",
        "unknown": "Desconhecido",
        "user cannot be deleted": "O usuário não pode ser excluído.",
        "user cannot be edited": "O usuário não pode ser editado.",
        "user cannot delete himself": "Um usuário não pode excluir seu próprio perfil.",
        "user date statuses": {
            "expired": "Expirado",
            "expires": "Expira",
            "never expires": "Nunca expira",
            "sent": "Enviado"
        },
        "user email": "E-mail do usuário",
        "user invitation cannot be cancelled": "O convite do usuário não pode ser cancelado.",
        "user invitation cannot be resent": "O convite do usuário não pode ser reenviado.",
        "user statuses": {
            "Active": "Ativo",
            "Inactive": "Inativo",
            "InvitationExpired": "Convite expirado",
            "InvitationPending": "Convite pendente"
        },
        "users": "Usuários",
        "value from": "Valor a partir de",
        "value to": "Valor para",
        "view all roles": "Ver tudo ({{count}})",
        "vin": "VIN",
        "vip status": "Status VIP",
        "visibility": "Visibilidade"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Informações sobre permissões",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Nome da interface do acessório.",
                    "type": "tipo de acessório conectado."
                },
                "can": {
                    "assigned package": "O pacote OEM atribuído ao dispositivo.",
                    "can oem file package": "O pacote OEM relatado durante a última conexão.",
                    "can oem file vehicle": "A configuração do veículo OEM relatada durante a última conexão.",
                    "dtb": "",
                    "firmware": "A versão do firmware CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "A última string de inicialização do adaptador CAN recebida, contendo os dados atuais e o número do programa do adaptador.",
                    "program number": "O número do programa do adaptador CAN.",
                    "revision": "",
                    "software date": "A data do software do adaptador CAN.",
                    "type": "O tipo de adaptador CAN."
                },
                "configuration details": {
                    "1_wire_authorization": "Nome do último arquivo de lista de autorização 1-Wire enviado.",
                    "bluetooth_authorization": "Nome do último arquivo de lista de autorizações Bluetooth enviado.",
                    "main configuration": "Nome do último arquivo de configuração principal enviado.",
                    "manual_geofence_scenarios": "Nome do último arquivo de lista de geofence manual enviado."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "A versão do firmware BLE relatada durante a última conexão.",
                    "bluetooth password": "",
                    "bootloader": "A versão do bootloader do dispositivo relatada durante a última conexão.",
                    "company": "A empresa proprietária deste dispositivo.",
                    "configuration": "Nome do último arquivo de configuração enviado pelo Configurator.",
                    "description": "Descrição do dispositivo (definida pelo usuário).",
                    "dtb": "A versão do blob da árvore de dispositivos relatada durante a última conexão.",
                    "firmware": "A versão do firmware do dispositivo relatada durante a última conexão.",
                    "gnss version": "A versão do GNSS relatada durante a última conexão.",
                    "group": "O grupo de dispositivos ao qual este dispositivo está atribuído.",
                    "product code": "O código do produto do dispositivo.",
                    "serial": "o número de série do dispositivo."
                },
                "obd": {
                    "obd chip firmware version": "A versão do firmware do chip OBD relatada durante a última conexão.",
                    "vin": "Um código único de 17 caracteres que identifica um veículo motorizado específico."
                },
                "sim": {
                    "gsm number": "O número de telefone público associado a um dispositivo.",
                    "iccid": "Um número de série único que identifica um cartão SIM.",
                    "imsi": "Um identificador único para um assinante de rede móvel."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "data e hora da criação do usuário.",
                    "id": "ID exclusivo do usuário.",
                    "invited by": "Endereço de e-mail do usuário que criou o convite.",
                    "role": "Funções atribuídas ao usuário.",
                    "updated at": "data e hora da última atualização do usuário."
                }
            }
        },
        "user details": "Detalhes do usuário"
    },
    "Task groups": {
        "all": "Todos",
        "bulk type": {
            "CompanyBulkDelete": "Excluir empresa",
            "DeviceBulkCreate": "Adicionar dispositivo",
            "DeviceBulkDelete": "Excluir dispositivo",
            "DeviceBulkUpdate": "Atualizar dispositivo",
            "FileBulkDelete": "Excluir arquivo",
            "GroupBulkDelete": "Excluir grupo",
            "TaskBulkCreate": "Criar tarefa",
            "TaskBulkUpdate": "Cancelar tarefa",
            "UserBulkDelete": "Excluir usuário"
        },
        "pending approval": "Aguardando aprovação",
        "already approved": "Já aprovado",
        "no approval required": "Não é necessária aprovação",
        "total objects": "Total de objetos",
        "total tasks": "Total de tarefas"
    },
    "Task status": {
        "0": "Pendente",
        "1": "Em execução",
        "2": "Concluído",
        "3": "Concluído com erros",
        "4": "Cancelado",
        "5": "Falha",
        "6": "Expirado",
        "7": "Aguardando aprovação",
        "8": "Verificando",
        "task count": {
            "0": "Tarefas pendentes",
            "1": "Execução de tarefas",
            "3": "Tarefas concluídas com erros",
            "5": "Tarefas com falha"
        },
        "verified tooltip title": "A tarefa foi concluída com sucesso e verificada pelo dispositivo."
    },
    "Tasks": {
        "0": "A tarefa está na fila e agora está pendente.",
        "1": "A tarefa está em execução no momento.",
        "2": "A tarefa foi concluída com sucesso.",
        "3": "A tarefa foi concluída, mas ocorreram alguns erros.",
        "4": "A tarefa foi cancelada.",
        "5": "A tarefa falhou.",
        "6": "A tarefa não foi concluída dentro de um determinado prazo."
    },
    "Tct": {
        "edit configuration": "Editar configuração",
        "no editable configurations": "Nenhuma configuração editável é carregada",
        "open tct": "Versão web aberta do TCT web",
        "open tct description": "Escolha criar uma nova configuração na versão TCT web ou edite um arquivo de configuração existente a partir do FOTA WEB.",
        "select configuration file": "Selecione um arquivo de configuração que deseja editar na TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "A versão web do TCT está disponível apenas para o nível Premium da empresa."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
